
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Workplace: 'Workplace',
  Instance: 'Instance',
  InstanceActivity: 'InstanceActivity',
  RecordActivity: 'RecordActivity',
  Record: 'Record',
  RecordUniqueValue: 'RecordUniqueValue',
  RecordSelectedOption: 'RecordSelectedOption',
  FieldDefaultOption: 'FieldDefaultOption',
  RelationshipRecord: 'RelationshipRecord',
  Page: 'Page',
  MemberNavigationItem: 'MemberNavigationItem',
  NavigationItem: 'NavigationItem',
  Block: 'Block',
  Model: 'Model',
  Field: 'Field',
  FieldSection: 'FieldSection',
  DataNormalization: 'DataNormalization',
  FieldDefinitionNormalization: 'FieldDefinitionNormalization',
  FieldDefinition: 'FieldDefinition',
  FieldDefinitionOption: 'FieldDefinitionOption',
  Relationship: 'Relationship',
  RelationshipLink: 'RelationshipLink',
  Setting: 'Setting',
  TaxRate: 'TaxRate',
  TaxLine: 'TaxLine',
  Checkout: 'Checkout',
  Admission: 'Admission',
  DependantLineAssignment: 'DependantLineAssignment',
  Line: 'Line',
  Order: 'Order',
  DraftOrder: 'DraftOrder',
  TerminalReader: 'TerminalReader',
  Location: 'Location',
  Space: 'Space',
  File: 'File',
  Transaction: 'Transaction',
  Invoice: 'Invoice',
  InvoiceLine: 'InvoiceLine',
  Refund: 'Refund',
  RefundLine: 'RefundLine',
  Amount: 'Amount',
  Payout: 'Payout',
  BalanceTransaction: 'BalanceTransaction',
  Customer: 'Customer',
  Dependant: 'Dependant',
  Image: 'Image',
  Service: 'Service',
  NotificationTemplate: 'NotificationTemplate',
  NotificationTopic: 'NotificationTopic',
  Notification: 'Notification',
  Address: 'Address',
  Product: 'Product',
  ProductVariant: 'ProductVariant',
  Inventory: 'Inventory',
  Member: 'Member',
  CliToken: 'CliToken',
  Contact: 'Contact',
  ContactAssociation: 'ContactAssociation',
  ContactBlock: 'ContactBlock',
  App: 'App',
  Deployment: 'Deployment',
  DeploymentWorkflowVersion: 'DeploymentWorkflowVersion',
  PendingDeployment: 'PendingDeployment',
  Executable: 'Executable',
  AppInstallation: 'AppInstallation',
  AppInstallSetupStep: 'AppInstallSetupStep',
  AppCrmMap: 'AppCrmMap',
  CommunicationChannel: 'CommunicationChannel',
  AppField: 'AppField',
  AppModel: 'AppModel',
  CommunicationChannelSubscription: 'CommunicationChannelSubscription',
  EnvVariable: 'EnvVariable',
  AppVersion: 'AppVersion',
  AppAccess: 'AppAccess',
  AppResource: 'AppResource',
  AppResourceDependency: 'AppResourceDependency',
  AppResourceInstance: 'AppResourceInstance',
  DedicatedPhoneNumber: 'DedicatedPhoneNumber',
  Chat: 'Chat',
  ChatMessage: 'ChatMessage',
  Tool: 'Tool',
  AgentRun: 'AgentRun',
  ToolCall: 'ToolCall',
  MessageAttachment: 'MessageAttachment',
  WorkflowVersion: 'WorkflowVersion',
  AppVersionWorkflowVersion: 'AppVersionWorkflowVersion',
  ChatReadCursor: 'ChatReadCursor',
  MemberInboxCursor: 'MemberInboxCursor',
  Webhook: 'Webhook',
  WebhookRegistration: 'WebhookRegistration',
  CronCursor: 'CronCursor',
  CronSubscription: 'CronSubscription',
  EventListener: 'EventListener',
  Workflow: 'Workflow',
  WorkflowRun: 'WorkflowRun',
  WorkflowRunStep: 'WorkflowRunStep',
  Agent: 'Agent',
  AgentVersion: 'AgentVersion',
  Skill: 'Skill',
  SkillVersion: 'SkillVersion',
  AgentConversation: 'AgentConversation',
  AgentConversationMessage: 'AgentConversationMessage',
  AgentContext: 'AgentContext',
  Trigger: 'Trigger',
  TriggerEvent: 'TriggerEvent',
  PageComponent: 'PageComponent',
  BatchJob: 'BatchJob',
  Action: 'Action',
  CustomResourceModel: 'CustomResourceModel',
  CustomResource: 'CustomResource',
  Campaign: 'Campaign',
  CampaignGoal: 'CampaignGoal',
  CampaignParticipant: 'CampaignParticipant',
  Metafield: 'Metafield',
  MetafieldValue: 'MetafieldValue',
  MetafieldDefinition: 'MetafieldDefinition',
  MetafieldDefinitionOption: 'MetafieldDefinitionOption',
  InputType: 'InputType',
  Import: 'Import',
  ImportRow: 'ImportRow',
  Migration: 'Migration',
  WorkplaceMigration: 'WorkplaceMigration',
  LlmProvider: 'LlmProvider',
  LlmModel: 'LlmModel',
  LlmUsage: 'LlmUsage',
  Provision: 'Provision',
  ReportDefinition: 'ReportDefinition',
  CRMMigration: 'CRMMigration',
  CRMOperation: 'CRMOperation',
  ThreadWorkflowRun: 'ThreadWorkflowRun',
  Participant: 'Participant',
  Thread: 'Thread',
  ThreadParticipant: 'ThreadParticipant',
  ScheduledEvent: 'ScheduledEvent',
  ScheduledMessage: 'ScheduledMessage',
  ThreadMessage: 'ThreadMessage',
  ThreadMessageAttachment: 'ThreadMessageAttachment',
  MessageOutbox: 'MessageOutbox',
  MessageInbox: 'MessageInbox',
  Event: 'Event',
  EventSubscription: 'EventSubscription',
  ThreadBlock: 'ThreadBlock',
  ThreadReadCursor: 'ThreadReadCursor',
  ThreadContext: 'ThreadContext',
  ThreadLink: 'ThreadLink',
  ThreadTopic: 'ThreadTopic',
  MessageTopic: 'MessageTopic',
  MessageTag: 'MessageTag',
  MessageTagAssignment: 'MessageTagAssignment',
  DecisionType: 'DecisionType',
  ThreadDecision: 'ThreadDecision',
  ThreadSummary: 'ThreadSummary',
  MessageEmbedding: 'MessageEmbedding',
  CallSession: 'CallSession',
  CallRecordingChunk: 'CallRecordingChunk',
  CallParticipant: 'CallParticipant',
  MessageReaction: 'MessageReaction',
  MessageMention: 'MessageMention'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = {
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const WorkplaceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  subdomain: 'subdomain',
  clerkOrganizationId: 'clerkOrganizationId',
  phone: 'phone',
  stripeAccountId: 'stripeAccountId',
  language: 'language',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  profileImageUrl: 'profileImageUrl',
  commissionRate: 'commissionRate',
  stripeDetailsSubmitted: 'stripeDetailsSubmitted',
  draftOrdersCount: 'draftOrdersCount',
  ordersCount: 'ordersCount',
  ciGenerated: 'ciGenerated',
  stripeAccountUrl: 'stripeAccountUrl',
  lastSetupAt: 'lastSetupAt',
  unreadMessageCount: 'unreadMessageCount',
  agentPersona: 'agentPersona',
  businessInformation: 'businessInformation',
  maxConcurrentDeployments: 'maxConcurrentDeployments'
} as const

export type WorkplaceScalarFieldEnum = (typeof WorkplaceScalarFieldEnum)[keyof typeof WorkplaceScalarFieldEnum]


export const InstanceScalarFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workplaceId: 'workplaceId',
  label: 'label',
  labelComputedAt: 'labelComputedAt',
  labelDirty: 'labelDirty',
  image: 'image',
  imageComputedAt: 'imageComputedAt',
  imageDirty: 'imageDirty',
  imageSeed: 'imageSeed',
  appInstallationId: 'appInstallationId',
  deletedAt: 'deletedAt'
} as const

export type InstanceScalarFieldEnum = (typeof InstanceScalarFieldEnum)[keyof typeof InstanceScalarFieldEnum]


export const InstanceActivityScalarFieldEnum = {
  id: 'id',
  instanceId: 'instanceId',
  event: 'event',
  meta: 'meta',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  context: 'context'
} as const

export type InstanceActivityScalarFieldEnum = (typeof InstanceActivityScalarFieldEnum)[keyof typeof InstanceActivityScalarFieldEnum]


export const RecordActivityScalarFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  fromData: 'fromData',
  toData: 'toData',
  instanceId: 'instanceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  instanceActivityId: 'instanceActivityId',
  context: 'context'
} as const

export type RecordActivityScalarFieldEnum = (typeof RecordActivityScalarFieldEnum)[keyof typeof RecordActivityScalarFieldEnum]


export const RecordScalarFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  instanceId: 'instanceId',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workplaceId: 'workplaceId',
  deletedAt: 'deletedAt',
  communicationChannelSubscriptionId: 'communicationChannelSubscriptionId'
} as const

export type RecordScalarFieldEnum = (typeof RecordScalarFieldEnum)[keyof typeof RecordScalarFieldEnum]


export const RecordUniqueValueScalarFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  fieldId: 'fieldId',
  workplaceId: 'workplaceId',
  value: 'value',
  instanceId: 'instanceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RecordUniqueValueScalarFieldEnum = (typeof RecordUniqueValueScalarFieldEnum)[keyof typeof RecordUniqueValueScalarFieldEnum]


export const RecordSelectedOptionScalarFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  optionId: 'optionId'
} as const

export type RecordSelectedOptionScalarFieldEnum = (typeof RecordSelectedOptionScalarFieldEnum)[keyof typeof RecordSelectedOptionScalarFieldEnum]


export const FieldDefaultOptionScalarFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  optionId: 'optionId'
} as const

export type FieldDefaultOptionScalarFieldEnum = (typeof FieldDefaultOptionScalarFieldEnum)[keyof typeof FieldDefaultOptionScalarFieldEnum]


export const RelationshipRecordScalarFieldEnum = {
  id: 'id',
  sourceInstanceId: 'sourceInstanceId',
  targetInstanceId: 'targetInstanceId',
  sortOrder: 'sortOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workplaceId: 'workplaceId',
  relationshipLinkId: 'relationshipLinkId',
  deletedAt: 'deletedAt'
} as const

export type RelationshipRecordScalarFieldEnum = (typeof RelationshipRecordScalarFieldEnum)[keyof typeof RelationshipRecordScalarFieldEnum]


export const PageScalarFieldEnum = {
  id: 'id',
  path: 'path',
  parentPageId: 'parentPageId',
  type: 'type',
  title: 'title',
  icon: 'icon',
  modelId: 'modelId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  isDefault: 'isDefault',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  baseQuery: 'baseQuery'
} as const

export type PageScalarFieldEnum = (typeof PageScalarFieldEnum)[keyof typeof PageScalarFieldEnum]


export const MemberNavigationItemScalarFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  pageId: 'pageId',
  url: 'url',
  label: 'label',
  icon: 'icon',
  sortIndex: 'sortIndex',
  parentId: 'parentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MemberNavigationItemScalarFieldEnum = (typeof MemberNavigationItemScalarFieldEnum)[keyof typeof MemberNavigationItemScalarFieldEnum]


export const NavigationItemScalarFieldEnum = {
  id: 'id',
  url: 'url',
  label: 'label',
  icon: 'icon',
  sortIndex: 'sortIndex',
  parentId: 'parentId',
  pageId: 'pageId',
  workplaceId: 'workplaceId',
  hidden: 'hidden',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NavigationItemScalarFieldEnum = (typeof NavigationItemScalarFieldEnum)[keyof typeof NavigationItemScalarFieldEnum]


export const BlockScalarFieldEnum = {
  id: 'id',
  order: 'order',
  pageId: 'pageId',
  title: 'title',
  modelId: 'modelId',
  query: 'query',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  config: 'config',
  default: 'default',
  relationshipLinkId: 'relationshipLinkId',
  type: 'type'
} as const

export type BlockScalarFieldEnum = (typeof BlockScalarFieldEnum)[keyof typeof BlockScalarFieldEnum]


export const ModelScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  labelTemplate: 'labelTemplate',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  positionX: 'positionX',
  positionY: 'positionY',
  handlePlural: 'handlePlural',
  namePlural: 'namePlural',
  description: 'description',
  imageEnabled: 'imageEnabled',
  imageSeedTemplate: 'imageSeedTemplate',
  contactable: 'contactable',
  system: 'system',
  deletedAt: 'deletedAt'
} as const

export type ModelScalarFieldEnum = (typeof ModelScalarFieldEnum)[keyof typeof ModelScalarFieldEnum]


export const FieldScalarFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  definitionId: 'definitionId',
  description: 'description',
  handle: 'handle',
  type: 'type',
  isUnique: 'isUnique',
  isList: 'isList',
  defaultValue: 'defaultValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workplaceId: 'workplaceId',
  label: 'label',
  relationshipLinkId: 'relationshipLinkId',
  validationMessages: 'validationMessages',
  appearance: 'appearance',
  requirement: 'requirement',
  system: 'system',
  deletedAt: 'deletedAt',
  visibility: 'visibility',
  permissions: 'permissions',
  aiMeta: 'aiMeta',
  sectionId: 'sectionId'
} as const

export type FieldScalarFieldEnum = (typeof FieldScalarFieldEnum)[keyof typeof FieldScalarFieldEnum]


export const FieldSectionScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  handle: 'handle',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FieldSectionScalarFieldEnum = (typeof FieldSectionScalarFieldEnum)[keyof typeof FieldSectionScalarFieldEnum]


export const DataNormalizationScalarFieldEnum = {
  name: 'name',
  description: 'description',
  handle: 'handle',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  icon: 'icon'
} as const

export type DataNormalizationScalarFieldEnum = (typeof DataNormalizationScalarFieldEnum)[keyof typeof DataNormalizationScalarFieldEnum]


export const FieldDefinitionNormalizationScalarFieldEnum = {
  id: 'id',
  sortOrder: 'sortOrder',
  arguments: 'arguments',
  fieldDefinitionId: 'fieldDefinitionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  handle: 'handle'
} as const

export type FieldDefinitionNormalizationScalarFieldEnum = (typeof FieldDefinitionNormalizationScalarFieldEnum)[keyof typeof FieldDefinitionNormalizationScalarFieldEnum]


export const FieldDefinitionScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  type: 'type',
  regexPattern: 'regexPattern',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lazyLoadingEnabled: 'lazyLoadingEnabled',
  limitChoices: 'limitChoices',
  appearance: 'appearance',
  validationMessages: 'validationMessages',
  isPrivate: 'isPrivate',
  hasOptions: 'hasOptions',
  shape: 'shape'
} as const

export type FieldDefinitionScalarFieldEnum = (typeof FieldDefinitionScalarFieldEnum)[keyof typeof FieldDefinitionScalarFieldEnum]


export const FieldDefinitionOptionScalarFieldEnum = {
  id: 'id',
  fieldDefinitionId: 'fieldDefinitionId',
  label: 'label',
  value: 'value',
  icon: 'icon',
  color: 'color'
} as const

export type FieldDefinitionOptionScalarFieldEnum = (typeof FieldDefinitionOptionScalarFieldEnum)[keyof typeof FieldDefinitionOptionScalarFieldEnum]


export const RelationshipScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type RelationshipScalarFieldEnum = (typeof RelationshipScalarFieldEnum)[keyof typeof RelationshipScalarFieldEnum]


export const RelationshipLinkScalarFieldEnum = {
  id: 'id',
  cardinality: 'cardinality',
  relationshipId: 'relationshipId',
  targetModelId: 'targetModelId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  handlePosition: 'handlePosition',
  sourceModelId: 'sourceModelId',
  onDeleteBehavior: 'onDeleteBehavior',
  deletedAt: 'deletedAt'
} as const

export type RelationshipLinkScalarFieldEnum = (typeof RelationshipLinkScalarFieldEnum)[keyof typeof RelationshipLinkScalarFieldEnum]


export const SettingScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SettingScalarFieldEnum = (typeof SettingScalarFieldEnum)[keyof typeof SettingScalarFieldEnum]


export const TaxRateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  rate: 'rate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  country: 'country'
} as const

export type TaxRateScalarFieldEnum = (typeof TaxRateScalarFieldEnum)[keyof typeof TaxRateScalarFieldEnum]


export const TaxLineScalarFieldEnum = {
  id: 'id',
  lineId: 'lineId',
  invoiceId: 'invoiceId',
  invoiceLineId: 'invoiceLineId',
  orderId: 'orderId',
  name: 'name',
  taxRateId: 'taxRateId',
  taxAmountId: 'taxAmountId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  refundId: 'refundId'
} as const

export type TaxLineScalarFieldEnum = (typeof TaxLineScalarFieldEnum)[keyof typeof TaxLineScalarFieldEnum]


export const CheckoutScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  completedAt: 'completedAt',
  email: 'email',
  phone: 'phone',
  note: 'note',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  currency: 'currency',
  draftOrderId: 'draftOrderId',
  expiresAt: 'expiresAt',
  stripeCheckoutId: 'stripeCheckoutId',
  invoiceId: 'invoiceId',
  orderId: 'orderId',
  stripeClientSecret: 'stripeClientSecret',
  token: 'token',
  firstName: 'firstName',
  lastName: 'lastName'
} as const

export type CheckoutScalarFieldEnum = (typeof CheckoutScalarFieldEnum)[keyof typeof CheckoutScalarFieldEnum]


export const AdmissionScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  lineId: 'lineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dependantLineAssignmentId: 'dependantLineAssignmentId',
  calculatedPriceId: 'calculatedPriceId',
  priceRule: 'priceRule',
  sessionIndex: 'sessionIndex',
  chargedAt: 'chargedAt',
  minSessionLengthInMinutes: 'minSessionLengthInMinutes',
  billingDurationInMinutes: 'billingDurationInMinutes',
  dependantId: 'dependantId',
  serviceId: 'serviceId',
  status: 'status',
  sessionId: 'sessionId',
  invoicedAt: 'invoicedAt'
} as const

export type AdmissionScalarFieldEnum = (typeof AdmissionScalarFieldEnum)[keyof typeof AdmissionScalarFieldEnum]


export const DependantLineAssignmentScalarFieldEnum = {
  id: 'id',
  lineId: 'lineId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  dependantId: 'dependantId'
} as const

export type DependantLineAssignmentScalarFieldEnum = (typeof DependantLineAssignmentScalarFieldEnum)[keyof typeof DependantLineAssignmentScalarFieldEnum]


export const LineScalarFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  orderId: 'orderId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  draftOrderId: 'draftOrderId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  quantity: 'quantity',
  serviceId: 'serviceId',
  priceId: 'priceId',
  rateId: 'rateId',
  invoicedAt: 'invoicedAt'
} as const

export type LineScalarFieldEnum = (typeof LineScalarFieldEnum)[keyof typeof LineScalarFieldEnum]


export const OrderScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  draftOrderId: 'draftOrderId',
  currency: 'currency',
  name: 'name',
  number: 'number',
  runningSubtotalId: 'runningSubtotalId',
  runningTotalId: 'runningTotalId',
  runningTotalTaxId: 'runningTotalTaxId',
  totalPaidId: 'totalPaidId',
  pendingSubtotalId: 'pendingSubtotalId',
  pendingTotalId: 'pendingTotalId',
  pendingTotalTaxId: 'pendingTotalTaxId',
  email: 'email',
  defaultLocationId: 'defaultLocationId',
  totalRefundedId: 'totalRefundedId',
  cancelledAt: 'cancelledAt',
  paymentStatus: 'paymentStatus',
  refundStatus: 'refundStatus',
  indexedAt: 'indexedAt'
} as const

export type OrderScalarFieldEnum = (typeof OrderScalarFieldEnum)[keyof typeof OrderScalarFieldEnum]


export const DraftOrderScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  memberId: 'memberId',
  processedAt: 'processedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  number: 'number',
  name: 'name',
  runningSubtotalId: 'runningSubtotalId',
  runningTotalId: 'runningTotalId',
  runningTotalTaxId: 'runningTotalTaxId',
  currency: 'currency',
  email: 'email',
  locationId: 'locationId'
} as const

export type DraftOrderScalarFieldEnum = (typeof DraftOrderScalarFieldEnum)[keyof typeof DraftOrderScalarFieldEnum]


export const TerminalReaderScalarFieldEnum = {
  id: 'id',
  stripeReaderId: 'stripeReaderId',
  workplaceId: 'workplaceId',
  locationId: 'locationId',
  serialNumber: 'serialNumber',
  status: 'status',
  deviceType: 'deviceType',
  deviceSWVersion: 'deviceSWVersion',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  draftOrderId: 'draftOrderId',
  orderId: 'orderId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  actionStatus: 'actionStatus',
  stripeWebhookUpdateCounter: 'stripeWebhookUpdateCounter'
} as const

export type TerminalReaderScalarFieldEnum = (typeof TerminalReaderScalarFieldEnum)[keyof typeof TerminalReaderScalarFieldEnum]


export const LocationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  addressId: 'addressId',
  memberId: 'memberId',
  acceptsInventory: 'acceptsInventory',
  businessHours: 'businessHours',
  timezone: 'timezone',
  stripeLocationId: 'stripeLocationId'
} as const

export type LocationScalarFieldEnum = (typeof LocationScalarFieldEnum)[keyof typeof LocationScalarFieldEnum]


export const SpaceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  locationId: 'locationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  color: 'color',
  memberId: 'memberId'
} as const

export type SpaceScalarFieldEnum = (typeof SpaceScalarFieldEnum)[keyof typeof SpaceScalarFieldEnum]


export const FileScalarFieldEnum = {
  id: 'id',
  key: 'key',
  mimeType: 'mimeType',
  size: 'size',
  private: 'private',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  publicUrl: 'publicUrl',
  hidden: 'hidden',
  lastUpdatedById: 'lastUpdatedById'
} as const

export type FileScalarFieldEnum = (typeof FileScalarFieldEnum)[keyof typeof FileScalarFieldEnum]


export const TransactionScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  invoiceId: 'invoiceId',
  amountId: 'amountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paymentMethod: 'paymentMethod',
  kind: 'kind',
  orderId: 'orderId',
  processedAt: 'processedAt',
  stripeChargeId: 'stripeChargeId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripeRefundId: 'stripeRefundId',
  locationId: 'locationId',
  refundId: 'refundId',
  channel: 'channel'
} as const

export type TransactionScalarFieldEnum = (typeof TransactionScalarFieldEnum)[keyof typeof TransactionScalarFieldEnum]


export const InvoiceScalarFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  hostedInvoiceUrl: 'hostedInvoiceUrl',
  status: 'status',
  totalId: 'totalId',
  totalTaxId: 'totalTaxId',
  workplaceId: 'workplaceId',
  stripeInvoiceId: 'stripeInvoiceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  indexedAt: 'indexedAt',
  currency: 'currency',
  email: 'email',
  name: 'name',
  note: 'note',
  phone: 'phone',
  subtotalId: 'subtotalId',
  totalNetId: 'totalNetId',
  totalRefundedId: 'totalRefundedId',
  memberId: 'memberId',
  orderId: 'orderId',
  totalPaidId: 'totalPaidId',
  locationId: 'locationId'
} as const

export type InvoiceScalarFieldEnum = (typeof InvoiceScalarFieldEnum)[keyof typeof InvoiceScalarFieldEnum]


export const InvoiceLineScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  description: 'description',
  quantity: 'quantity',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productVariantId: 'productVariantId',
  checkoutId: 'checkoutId',
  lineId: 'lineId',
  priceId: 'priceId',
  serviceId: 'serviceId',
  stripeCheckoutLineId: 'stripeCheckoutLineId',
  admissionId: 'admissionId',
  orderId: 'orderId',
  draftOrderId: 'draftOrderId',
  stripeInvoiceLineId: 'stripeInvoiceLineId',
  refundedQuantity: 'refundedQuantity'
} as const

export type InvoiceLineScalarFieldEnum = (typeof InvoiceLineScalarFieldEnum)[keyof typeof InvoiceLineScalarFieldEnum]


export const RefundScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  orderId: 'orderId',
  invoiceId: 'invoiceId',
  totalId: 'totalId',
  totalTaxId: 'totalTaxId',
  currency: 'currency',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason'
} as const

export type RefundScalarFieldEnum = (typeof RefundScalarFieldEnum)[keyof typeof RefundScalarFieldEnum]


export const RefundLineScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  orderId: 'orderId',
  refundId: 'refundId',
  invoiceId: 'invoiceId',
  invoiceLineId: 'invoiceLineId',
  lineId: 'lineId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quantity: 'quantity'
} as const

export type RefundLineScalarFieldEnum = (typeof RefundLineScalarFieldEnum)[keyof typeof RefundLineScalarFieldEnum]


export const AmountScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  currency: 'currency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AmountScalarFieldEnum = (typeof AmountScalarFieldEnum)[keyof typeof AmountScalarFieldEnum]


export const PayoutScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  stripePayoutId: 'stripePayoutId',
  stripePayoutStatus: 'stripePayoutStatus',
  totalAmountId: 'totalAmountId',
  currency: 'currency',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fetchedTransactions: 'fetchedTransactions',
  stripeWebhookUpdateCounter: 'stripeWebhookUpdateCounter',
  arrivesAt: 'arrivesAt'
} as const

export type PayoutScalarFieldEnum = (typeof PayoutScalarFieldEnum)[keyof typeof PayoutScalarFieldEnum]


export const BalanceTransactionScalarFieldEnum = {
  id: 'id',
  amountId: 'amountId',
  netAmountId: 'netAmountId',
  description: 'description',
  skedyulFeeId: 'skedyulFeeId',
  stripeFeeId: 'stripeFeeId',
  netFeeId: 'netFeeId',
  type: 'type',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payoutId: 'payoutId',
  stripeBalanceTransactionId: 'stripeBalanceTransactionId',
  availableAt: 'availableAt'
} as const

export type BalanceTransactionScalarFieldEnum = (typeof BalanceTransactionScalarFieldEnum)[keyof typeof BalanceTransactionScalarFieldEnum]


export const CustomerScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  memberId: 'memberId',
  stripeCustomerId: 'stripeCustomerId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billingAddressId: 'billingAddressId',
  dependantsEnabled: 'dependantsEnabled'
} as const

export type CustomerScalarFieldEnum = (typeof CustomerScalarFieldEnum)[keyof typeof CustomerScalarFieldEnum]


export const DependantScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  contactable: 'contactable',
  memberId: 'memberId',
  customerId: 'customerId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  indexedAt: 'indexedAt',
  isActingAsCustomer: 'isActingAsCustomer',
  profileImageUrl: 'profileImageUrl'
} as const

export type DependantScalarFieldEnum = (typeof DependantScalarFieldEnum)[keyof typeof DependantScalarFieldEnum]


export const ImageScalarFieldEnum = {
  id: 'id',
  key: 'key',
  name: 'name',
  mimeType: 'mimeType',
  size: 'size',
  private: 'private',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ImageScalarFieldEnum = (typeof ImageScalarFieldEnum)[keyof typeof ImageScalarFieldEnum]


export const ServiceScalarFieldEnum = {
  id: 'id',
  status: 'status',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  priceId: 'priceId',
  priceRule: 'priceRule',
  sessionFrequency: 'sessionFrequency',
  sessionInterval: 'sessionInterval',
  maxAttendees: 'maxAttendees',
  minSessionLengthInMinutes: 'minSessionLengthInMinutes',
  depositId: 'depositId',
  color: 'color',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enableWaitList: 'enableWaitList',
  sessionCreationMode: 'sessionCreationMode',
  approvalRequired: 'approvalRequired',
  maxSessionLengthInMinutes: 'maxSessionLengthInMinutes',
  indexedAt: 'indexedAt'
} as const

export type ServiceScalarFieldEnum = (typeof ServiceScalarFieldEnum)[keyof typeof ServiceScalarFieldEnum]


export const NotificationTemplateScalarFieldEnum = {
  id: 'id',
  subject: 'subject',
  notificationTopicId: 'notificationTopicId',
  workplaceId: 'workplaceId',
  deliveryMethod: 'deliveryMethod',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fileId: 'fileId'
} as const

export type NotificationTemplateScalarFieldEnum = (typeof NotificationTemplateScalarFieldEnum)[keyof typeof NotificationTemplateScalarFieldEnum]


export const NotificationTopicScalarFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle',
  params: 'params',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailEnabled: 'emailEnabled',
  pushEnabled: 'pushEnabled',
  smsEnabled: 'smsEnabled'
} as const

export type NotificationTopicScalarFieldEnum = (typeof NotificationTopicScalarFieldEnum)[keyof typeof NotificationTopicScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  sentAt: 'sentAt',
  lastRetriedAt: 'lastRetriedAt',
  retries: 'retries',
  subject: 'subject',
  deliveryMethod: 'deliveryMethod',
  sender: 'sender',
  recipient: 'recipient',
  senderName: 'senderName',
  workplaceId: 'workplaceId',
  notificationTopicId: 'notificationTopicId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contentKey: 'contentKey'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const AddressScalarFieldEnum = {
  id: 'id',
  company: 'company',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  email: 'email',
  street1: 'street1',
  street2: 'street2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AddressScalarFieldEnum = (typeof AddressScalarFieldEnum)[keyof typeof AddressScalarFieldEnum]


export const ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memberId: 'memberId',
  status: 'status'
} as const

export type ProductScalarFieldEnum = (typeof ProductScalarFieldEnum)[keyof typeof ProductScalarFieldEnum]


export const ProductVariantScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  workplaceId: 'workplaceId',
  name: 'name',
  sku: 'sku',
  priceAmountId: 'priceAmountId',
  comparePriceAmountId: 'comparePriceAmountId',
  default: 'default',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memberId: 'memberId',
  indexedAt: 'indexedAt'
} as const

export type ProductVariantScalarFieldEnum = (typeof ProductVariantScalarFieldEnum)[keyof typeof ProductVariantScalarFieldEnum]


export const InventoryScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  locationId: 'locationId',
  oversellQuantity: 'oversellQuantity',
  tracked: 'tracked',
  available: 'available',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InventoryScalarFieldEnum = (typeof InventoryScalarFieldEnum)[keyof typeof InventoryScalarFieldEnum]


export const MemberScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  clerkUserId: 'clerkUserId',
  clerkOrganizationMembershipId: 'clerkOrganizationMembershipId',
  clerkWebhookUpdateCounter: 'clerkWebhookUpdateCounter',
  firstName: 'firstName',
  lastName: 'lastName',
  profileImageUrl: 'profileImageUrl',
  email: 'email',
  phone: 'phone',
  revokedAt: 'revokedAt',
  color: 'color',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MemberScalarFieldEnum = (typeof MemberScalarFieldEnum)[keyof typeof MemberScalarFieldEnum]


export const CliTokenScalarFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  token: 'token',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CliTokenScalarFieldEnum = (typeof CliTokenScalarFieldEnum)[keyof typeof CliTokenScalarFieldEnum]


export const ContactScalarFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  dependantId: 'dependantId',
  lastMessage: 'lastMessage',
  lastContactedAt: 'lastContactedAt',
  lastActivityAt: 'lastActivityAt',
  unreadMessageCount: 'unreadMessageCount',
  name: 'name'
} as const

export type ContactScalarFieldEnum = (typeof ContactScalarFieldEnum)[keyof typeof ContactScalarFieldEnum]


export const ContactAssociationScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  contactId: 'contactId',
  instanceId: 'instanceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  channelModelLinkInstanceId: 'channelModelLinkInstanceId'
} as const

export type ContactAssociationScalarFieldEnum = (typeof ContactAssociationScalarFieldEnum)[keyof typeof ContactAssociationScalarFieldEnum]


export const ContactBlockScalarFieldEnum = {
  id: 'id',
  contactId: 'contactId',
  workplaceId: 'workplaceId',
  kind: 'kind',
  sequence: 'sequence',
  contentStructured: 'contentStructured',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ContactBlockScalarFieldEnum = (typeof ContactBlockScalarFieldEnum)[keyof typeof ContactBlockScalarFieldEnum]


export const AppScalarFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accentColor: 'accentColor',
  bannerUrl: 'bannerUrl',
  category: 'category',
  description: 'description',
  iconUrl: 'iconUrl',
  installsCount: 'installsCount',
  isFeatured: 'isFeatured',
  publisherLogoUrl: 'publisherLogoUrl',
  publisherName: 'publisherName',
  rating: 'rating',
  screenshotUrls: 'screenshotUrls',
  shortDescription: 'shortDescription',
  tags: 'tags',
  websiteUrl: 'websiteUrl',
  config: 'config',
  defaultBranch: 'defaultBranch',
  githubInstallationId: 'githubInstallationId',
  githubName: 'githubName',
  githubOwner: 'githubOwner',
  githubRepoId: 'githubRepoId',
  ownerId: 'ownerId',
  publishedAt: 'publishedAt',
  installOnWorkplaceSetup: 'installOnWorkplaceSetup'
} as const

export type AppScalarFieldEnum = (typeof AppScalarFieldEnum)[keyof typeof AppScalarFieldEnum]


export const DeploymentScalarFieldEnum = {
  id: 'id',
  status: 'status',
  imageTagId: 'imageTagId',
  imageUri: 'imageUri',
  logs: 'logs',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  temporalWorkflowId: 'temporalWorkflowId',
  buildContextS3Path: 'buildContextS3Path',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  computeLayer: 'computeLayer',
  runtime: 'runtime',
  workplaceId: 'workplaceId',
  appId: 'appId',
  commitMessage: 'commitMessage',
  gitBranch: 'gitBranch',
  gitCommitSha: 'gitCommitSha',
  gitOwner: 'gitOwner',
  gitRepo: 'gitRepo',
  gitRepoId: 'gitRepoId',
  projectDirectory: 'projectDirectory',
  sourceType: 'sourceType',
  mode: 'mode',
  githubCheckRunId: 'githubCheckRunId'
} as const

export type DeploymentScalarFieldEnum = (typeof DeploymentScalarFieldEnum)[keyof typeof DeploymentScalarFieldEnum]


export const DeploymentWorkflowVersionScalarFieldEnum = {
  id: 'id',
  deploymentId: 'deploymentId',
  workflowVersionId: 'workflowVersionId',
  createdAt: 'createdAt'
} as const

export type DeploymentWorkflowVersionScalarFieldEnum = (typeof DeploymentWorkflowVersionScalarFieldEnum)[keyof typeof DeploymentWorkflowVersionScalarFieldEnum]


export const PendingDeploymentScalarFieldEnum = {
  id: 'id',
  status: 'status',
  workplaceId: 'workplaceId',
  input: 'input',
  attempts: 'attempts',
  maxAttempts: 'maxAttempts',
  lastError: 'lastError',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PendingDeploymentScalarFieldEnum = (typeof PendingDeploymentScalarFieldEnum)[keyof typeof PendingDeploymentScalarFieldEnum]


export const ExecutableScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  deploymentId: 'deploymentId',
  invokeEndpoint: 'invokeEndpoint',
  arn: 'arn',
  status: 'status',
  lastInvokedAt: 'lastInvokedAt',
  errorMessage: 'errorMessage',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  config: 'config',
  workflowFiles: 'workflowFiles'
} as const

export type ExecutableScalarFieldEnum = (typeof ExecutableScalarFieldEnum)[keyof typeof ExecutableScalarFieldEnum]


export const AppInstallationScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  appId: 'appId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  appVersionId: 'appVersionId',
  authStatus: 'authStatus'
} as const

export type AppInstallationScalarFieldEnum = (typeof AppInstallationScalarFieldEnum)[keyof typeof AppInstallationScalarFieldEnum]


export const AppInstallSetupStepScalarFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  handle: 'handle',
  kind: 'kind',
  status: 'status',
  sortOrder: 'sortOrder',
  label: 'label',
  description: 'description',
  requires: 'requires',
  config: 'config',
  completedAt: 'completedAt',
  skippedAt: 'skippedAt',
  invalidatedAt: 'invalidatedAt',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppInstallSetupStepScalarFieldEnum = (typeof AppInstallSetupStepScalarFieldEnum)[keyof typeof AppInstallSetupStepScalarFieldEnum]


export const AppCrmMapScalarFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  entityHandle: 'entityHandle',
  targetModelId: 'targetModelId',
  matchFieldId: 'matchFieldId',
  matchRules: 'matchRules',
  fieldMappings: 'fieldMappings',
  relationshipMappings: 'relationshipMappings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invalidatedAt: 'invalidatedAt'
} as const

export type AppCrmMapScalarFieldEnum = (typeof AppCrmMapScalarFieldEnum)[keyof typeof AppCrmMapScalarFieldEnum]


export const CommunicationChannelScalarFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  identifierValue: 'identifierValue',
  status: 'status',
  prompt: 'prompt',
  handle: 'handle',
  icon: 'icon',
  inboundAutoJoinAgentId: 'inboundAutoJoinAgentId',
  inboundAutoJoinSenderPattern: 'inboundAutoJoinSenderPattern'
} as const

export type CommunicationChannelScalarFieldEnum = (typeof CommunicationChannelScalarFieldEnum)[keyof typeof CommunicationChannelScalarFieldEnum]


export const AppFieldScalarFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityHandle: 'entityHandle',
  fieldHandle: 'fieldHandle'
} as const

export type AppFieldScalarFieldEnum = (typeof AppFieldScalarFieldEnum)[keyof typeof AppFieldScalarFieldEnum]


export const AppModelScalarFieldEnum = {
  id: 'id',
  entityHandle: 'entityHandle',
  modelId: 'modelId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppModelScalarFieldEnum = (typeof AppModelScalarFieldEnum)[keyof typeof AppModelScalarFieldEnum]


export const CommunicationChannelSubscriptionScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  communicationChannelId: 'communicationChannelId',
  contactId: 'contactId',
  identifierValue: 'identifierValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  selected: 'selected',
  linkedIdentifierValueId: 'linkedIdentifierValueId',
  lastContactedAt: 'lastContactedAt',
  optIn: 'optIn'
} as const

export type CommunicationChannelSubscriptionScalarFieldEnum = (typeof CommunicationChannelSubscriptionScalarFieldEnum)[keyof typeof CommunicationChannelSubscriptionScalarFieldEnum]


export const EnvVariableScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  visibility: 'visibility',
  communicationChannelId: 'communicationChannelId',
  triggerId: 'triggerId',
  appInstallId: 'appInstallId',
  editable: 'editable',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastFour: 'lastFour',
  system: 'system',
  workplaceId: 'workplaceId',
  expiresAt: 'expiresAt',
  appVersionId: 'appVersionId',
  llmProviderId: 'llmProviderId',
  ownerLevel: 'ownerLevel'
} as const

export type EnvVariableScalarFieldEnum = (typeof EnvVariableScalarFieldEnum)[keyof typeof EnvVariableScalarFieldEnum]


export const AppVersionScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  executableId: 'executableId',
  handle: 'handle',
  isDefault: 'isDefault',
  name: 'name',
  projectDirectory: 'projectDirectory',
  isProd: 'isProd',
  isLocalDev: 'isLocalDev',
  lastHeartbeat: 'lastHeartbeat',
  localDevOwner: 'localDevOwner'
} as const

export type AppVersionScalarFieldEnum = (typeof AppVersionScalarFieldEnum)[keyof typeof AppVersionScalarFieldEnum]


export const AppAccessScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  workplaceId: 'workplaceId',
  enabledVersions: 'enabledVersions',
  grantedById: 'grantedById',
  note: 'note',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppAccessScalarFieldEnum = (typeof AppAccessScalarFieldEnum)[keyof typeof AppAccessScalarFieldEnum]


export const AppResourceScalarFieldEnum = {
  id: 'id',
  appVersionId: 'appVersionId',
  resourceType: 'resourceType',
  scope: 'scope',
  handle: 'handle',
  parentId: 'parentId',
  config: 'config',
  configHash: 'configHash',
  isEnabled: 'isEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppResourceScalarFieldEnum = (typeof AppResourceScalarFieldEnum)[keyof typeof AppResourceScalarFieldEnum]


export const AppResourceDependencyScalarFieldEnum = {
  id: 'id',
  dependentId: 'dependentId',
  dependencyId: 'dependencyId',
  requiredFields: 'requiredFields',
  createdAt: 'createdAt',
  conditions: 'conditions'
} as const

export type AppResourceDependencyScalarFieldEnum = (typeof AppResourceDependencyScalarFieldEnum)[keyof typeof AppResourceDependencyScalarFieldEnum]


export const AppResourceInstanceScalarFieldEnum = {
  id: 'id',
  appResourceId: 'appResourceId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId',
  targetId: 'targetId',
  dependsOnInstanceId: 'dependsOnInstanceId',
  configuredAtVersionId: 'configuredAtVersionId',
  status: 'status',
  driftReason: 'driftReason',
  driftDetectedAt: 'driftDetectedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AppResourceInstanceScalarFieldEnum = (typeof AppResourceInstanceScalarFieldEnum)[keyof typeof AppResourceInstanceScalarFieldEnum]


export const DedicatedPhoneNumberScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  phone: 'phone',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  birdChannelId: 'birdChannelId',
  forwardingPhoneNumber: 'forwardingPhoneNumber'
} as const

export type DedicatedPhoneNumberScalarFieldEnum = (typeof DedicatedPhoneNumberScalarFieldEnum)[keyof typeof DedicatedPhoneNumberScalarFieldEnum]


export const ChatScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  contactId: 'contactId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  token: 'token',
  otp: 'otp',
  verifiedAt: 'verifiedAt'
} as const

export type ChatScalarFieldEnum = (typeof ChatScalarFieldEnum)[keyof typeof ChatScalarFieldEnum]


export const ChatMessageScalarFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  contactId: 'contactId',
  memberId: 'memberId',
  message: 'message',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  receivedAt: 'receivedAt',
  sentAt: 'sentAt',
  workplaceId: 'workplaceId',
  remoteId: 'remoteId',
  subscriptionId: 'subscriptionId',
  generatedSummary: 'generatedSummary',
  contentUrl: 'contentUrl',
  title: 'title',
  lastAttemptAt: 'lastAttemptAt',
  aiGenerated: 'aiGenerated',
  agentId: 'agentId',
  workflowRunId: 'workflowRunId',
  workflowRunStepId: 'workflowRunStepId'
} as const

export type ChatMessageScalarFieldEnum = (typeof ChatMessageScalarFieldEnum)[keyof typeof ChatMessageScalarFieldEnum]


export const ToolScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  kind: 'kind',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  inputSchema: 'inputSchema',
  outputSchema: 'outputSchema',
  config: 'config',
  isEnabled: 'isEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSyncedAt: 'lastSyncedAt',
  modelId: 'modelId',
  triggerId: 'triggerId',
  targetAgentId: 'targetAgentId',
  appVersionId: 'appVersionId',
  executableId: 'executableId'
} as const

export type ToolScalarFieldEnum = (typeof ToolScalarFieldEnum)[keyof typeof ToolScalarFieldEnum]


export const AgentRunScalarFieldEnum = {
  id: 'id',
  agentId: 'agentId',
  chatId: 'chatId',
  agentConversationId: 'agentConversationId',
  triggerMessageId: 'triggerMessageId',
  status: 'status',
  error: 'error',
  trace: 'trace',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  llmModelId: 'llmModelId',
  threadId: 'threadId',
  parentRunId: 'parentRunId',
  queuedAt: 'queuedAt',
  retryCount: 'retryCount',
  triggerKind: 'triggerKind',
  agentVersionId: 'agentVersionId',
  triggerEventId: 'triggerEventId',
  temporalWorkflowId: 'temporalWorkflowId'
} as const

export type AgentRunScalarFieldEnum = (typeof AgentRunScalarFieldEnum)[keyof typeof AgentRunScalarFieldEnum]


export const ToolCallScalarFieldEnum = {
  id: 'id',
  agentRunId: 'agentRunId',
  toolId: 'toolId',
  input: 'input',
  output: 'output',
  status: 'status',
  error: 'error',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  executableId: 'executableId',
  agentConversationId: 'agentConversationId',
  threadId: 'threadId',
  providerOptions: 'providerOptions'
} as const

export type ToolCallScalarFieldEnum = (typeof ToolCallScalarFieldEnum)[keyof typeof ToolCallScalarFieldEnum]


export const MessageAttachmentScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  fileId: 'fileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MessageAttachmentScalarFieldEnum = (typeof MessageAttachmentScalarFieldEnum)[keyof typeof MessageAttachmentScalarFieldEnum]


export const WorkflowVersionScalarFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  version: 'version',
  versionLabel: 'versionLabel',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appId: 'appId',
  executableId: 'executableId',
  contentHash: 'contentHash'
} as const

export type WorkflowVersionScalarFieldEnum = (typeof WorkflowVersionScalarFieldEnum)[keyof typeof WorkflowVersionScalarFieldEnum]


export const AppVersionWorkflowVersionScalarFieldEnum = {
  id: 'id',
  appVersionId: 'appVersionId',
  workflowVersionId: 'workflowVersionId',
  createdAt: 'createdAt'
} as const

export type AppVersionWorkflowVersionScalarFieldEnum = (typeof AppVersionWorkflowVersionScalarFieldEnum)[keyof typeof AppVersionWorkflowVersionScalarFieldEnum]


export const ChatReadCursorScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  chatId: 'chatId',
  contactId: 'contactId',
  memberId: 'memberId',
  lastReadAt: 'lastReadAt',
  manualUnreadMessageId: 'manualUnreadMessageId',
  watching: 'watching',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ChatReadCursorScalarFieldEnum = (typeof ChatReadCursorScalarFieldEnum)[keyof typeof ChatReadCursorScalarFieldEnum]


export const MemberInboxCursorScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  inboxBaselineAt: 'inboxBaselineAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MemberInboxCursorScalarFieldEnum = (typeof MemberInboxCursorScalarFieldEnum)[keyof typeof MemberInboxCursorScalarFieldEnum]


export const WebhookScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appId: 'appId',
  requestMethods: 'requestMethods',
  handle: 'handle',
  displayName: 'displayName',
  description: 'description',
  appVersionId: 'appVersionId',
  lastSyncedAt: 'lastSyncedAt',
  isEnabled: 'isEnabled',
  level: 'level',
  type: 'type'
} as const

export type WebhookScalarFieldEnum = (typeof WebhookScalarFieldEnum)[keyof typeof WebhookScalarFieldEnum]


export const WebhookRegistrationScalarFieldEnum = {
  id: 'id',
  webhookId: 'webhookId',
  appInstallationId: 'appInstallationId',
  context: 'context',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  path: 'path',
  url: 'url'
} as const

export type WebhookRegistrationScalarFieldEnum = (typeof WebhookRegistrationScalarFieldEnum)[keyof typeof WebhookRegistrationScalarFieldEnum]


export const CronCursorScalarFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  cursorKey: 'cursorKey',
  cursor: 'cursor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CronCursorScalarFieldEnum = (typeof CronCursorScalarFieldEnum)[keyof typeof CronCursorScalarFieldEnum]


export const CronSubscriptionScalarFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  toolName: 'toolName',
  schedule: 'schedule',
  timezone: 'timezone',
  inputs: 'inputs',
  cursorKey: 'cursorKey',
  enabled: 'enabled',
  label: 'label',
  eventBridgeRuleArn: 'eventBridgeRuleArn',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CronSubscriptionScalarFieldEnum = (typeof CronSubscriptionScalarFieldEnum)[keyof typeof CronSubscriptionScalarFieldEnum]


export const EventListenerScalarFieldEnum = {
  id: 'id',
  type: 'type',
  inputs: 'inputs',
  triggerId: 'triggerId',
  condition: 'condition',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  identifierKey: 'identifierKey',
  inputsVersionId: 'inputsVersionId'
} as const

export type EventListenerScalarFieldEnum = (typeof EventListenerScalarFieldEnum)[keyof typeof EventListenerScalarFieldEnum]


export const WorkflowScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  handle: 'handle',
  memberId: 'memberId',
  publishedAt: 'publishedAt',
  updatedAt: 'updatedAt',
  publishTag: 'publishTag',
  appId: 'appId',
  installConfig: 'installConfig'
} as const

export type WorkflowScalarFieldEnum = (typeof WorkflowScalarFieldEnum)[keyof typeof WorkflowScalarFieldEnum]


export const WorkflowRunScalarFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  workflowVersionId: 'workflowVersionId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  startedAt: 'startedAt',
  inputs: 'inputs',
  cancelledAt: 'cancelledAt',
  pausedAt: 'pausedAt',
  batchJobId: 'batchJobId',
  failedAt: 'failedAt',
  activeWorkflowTagsCleanupAt: 'activeWorkflowTagsCleanupAt',
  activeWorkflowTagsCleanedUpAt: 'activeWorkflowTagsCleanedUpAt'
} as const

export type WorkflowRunScalarFieldEnum = (typeof WorkflowRunScalarFieldEnum)[keyof typeof WorkflowRunScalarFieldEnum]


export const WorkflowRunStepScalarFieldEnum = {
  id: 'id',
  name: 'name',
  workflowRunId: 'workflowRunId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  meta: 'meta',
  status: 'status',
  handle: 'handle',
  completedAt: 'completedAt',
  startedAt: 'startedAt',
  type: 'type',
  scheduledAt: 'scheduledAt',
  wait: 'wait',
  workflowVersionId: 'workflowVersionId',
  startedWaitingAt: 'startedWaitingAt',
  sortOrder: 'sortOrder',
  triggerId: 'triggerId'
} as const

export type WorkflowRunStepScalarFieldEnum = (typeof WorkflowRunStepScalarFieldEnum)[keyof typeof WorkflowRunStepScalarFieldEnum]


export const AgentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  system: 'system',
  description: 'description',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDefault: 'isDefault',
  modelId: 'modelId',
  llmModelId: 'llmModelId',
  appVersionId: 'appVersionId',
  handle: 'handle',
  isEnabled: 'isEnabled',
  kind: 'kind',
  persona: 'persona',
  personaName: 'personaName',
  flowPositionX: 'flowPositionX',
  flowPositionY: 'flowPositionY'
} as const

export type AgentScalarFieldEnum = (typeof AgentScalarFieldEnum)[keyof typeof AgentScalarFieldEnum]


export const AgentVersionScalarFieldEnum = {
  id: 'id',
  agentId: 'agentId',
  version: 'version',
  versionLabel: 'versionLabel',
  contentHash: 'contentHash',
  config: 'config',
  trafficWeight: 'trafficWeight',
  isPublished: 'isPublished',
  isDeprecated: 'isDeprecated',
  deprecatedAt: 'deprecatedAt',
  migrateToId: 'migrateToId',
  workplaceId: 'workplaceId',
  appId: 'appId',
  memberId: 'memberId',
  deploymentGroupId: 'deploymentGroupId',
  changeLog: 'changeLog',
  feedbackThreadId: 'feedbackThreadId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgentVersionScalarFieldEnum = (typeof AgentVersionScalarFieldEnum)[keyof typeof AgentVersionScalarFieldEnum]


export const SkillScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  appVersionId: 'appVersionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SkillScalarFieldEnum = (typeof SkillScalarFieldEnum)[keyof typeof SkillScalarFieldEnum]


export const SkillVersionScalarFieldEnum = {
  id: 'id',
  skillId: 'skillId',
  version: 'version',
  versionLabel: 'versionLabel',
  contentHash: 'contentHash',
  config: 'config',
  isPublished: 'isPublished',
  memberId: 'memberId',
  appVersionId: 'appVersionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type SkillVersionScalarFieldEnum = (typeof SkillVersionScalarFieldEnum)[keyof typeof SkillVersionScalarFieldEnum]


export const AgentConversationScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  tabId: 'tabId',
  title: 'title',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  agentId: 'agentId'
} as const

export type AgentConversationScalarFieldEnum = (typeof AgentConversationScalarFieldEnum)[keyof typeof AgentConversationScalarFieldEnum]


export const AgentConversationMessageScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  role: 'role',
  content: 'content',
  createdAt: 'createdAt',
  agentId: 'agentId'
} as const

export type AgentConversationMessageScalarFieldEnum = (typeof AgentConversationMessageScalarFieldEnum)[keyof typeof AgentConversationMessageScalarFieldEnum]


export const AgentContextScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  type: 'type',
  referenceId: 'referenceId',
  modelId: 'modelId',
  label: 'label',
  weight: 'weight',
  touchCount: 'touchCount',
  lastAction: 'lastAction',
  metadata: 'metadata',
  createdAt: 'createdAt',
  lastTouchedAt: 'lastTouchedAt',
  modelLabel: 'modelLabel'
} as const

export type AgentContextScalarFieldEnum = (typeof AgentContextScalarFieldEnum)[keyof typeof AgentContextScalarFieldEnum]


export const TriggerScalarFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  workflowVersionId: 'workflowVersionId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  handle: 'handle',
  appInstallationId: 'appInstallationId',
  defaultIdentifierKey: 'defaultIdentifierKey',
  config: 'config',
  type: 'type',
  manualConfig: 'manualConfig',
  isEnabled: 'isEnabled',
  followLatest: 'followLatest',
  inputMappings: 'inputMappings',
  eventConditions: 'eventConditions'
} as const

export type TriggerScalarFieldEnum = (typeof TriggerScalarFieldEnum)[keyof typeof TriggerScalarFieldEnum]


export const TriggerEventScalarFieldEnum = {
  id: 'id',
  triggerId: 'triggerId',
  info: 'info',
  workflowRunId: 'workflowRunId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TriggerEventScalarFieldEnum = (typeof TriggerEventScalarFieldEnum)[keyof typeof TriggerEventScalarFieldEnum]


export const PageComponentScalarFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  default: 'default',
  customResourceModelId: 'customResourceModelId',
  resource: 'resource',
  rowIndex: 'rowIndex',
  columnIndex: 'columnIndex',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expandable: 'expandable',
  expanded: 'expanded',
  hidden: 'hidden',
  parentCustomResourceModelId: 'parentCustomResourceModelId'
} as const

export type PageComponentScalarFieldEnum = (typeof PageComponentScalarFieldEnum)[keyof typeof PageComponentScalarFieldEnum]


export const BatchJobScalarFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  actionId: 'actionId',
  label: 'label',
  meta: 'meta',
  triggerId: 'triggerId',
  kind: 'kind',
  status: 'status',
  appInstallationId: 'appInstallationId'
} as const

export type BatchJobScalarFieldEnum = (typeof BatchJobScalarFieldEnum)[keyof typeof BatchJobScalarFieldEnum]


export const ActionScalarFieldEnum = {
  id: 'id',
  icon: 'icon',
  batch: 'batch',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  triggerId: 'triggerId',
  inputs: 'inputs',
  label: 'label',
  modelId: 'modelId',
  identifierKey: 'identifierKey',
  inputsVersionId: 'inputsVersionId'
} as const

export type ActionScalarFieldEnum = (typeof ActionScalarFieldEnum)[keyof typeof ActionScalarFieldEnum]


export const CustomResourceModelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  handle: 'handle',
  parentCoreResource: 'parentCoreResource',
  parentCustomResourceModelId: 'parentCustomResourceModelId',
  workplaceId: 'workplaceId',
  locked: 'locked',
  containsData: 'containsData',
  relationship: 'relationship',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  memberId: 'memberId',
  native: 'native',
  linkToCoreResource: 'linkToCoreResource',
  plural: 'plural',
  labelTemplate: 'labelTemplate'
} as const

export type CustomResourceModelScalarFieldEnum = (typeof CustomResourceModelScalarFieldEnum)[keyof typeof CustomResourceModelScalarFieldEnum]


export const CustomResourceScalarFieldEnum = {
  id: 'id',
  customResourceModelId: 'customResourceModelId',
  workplaceId: 'workplaceId',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  resource: 'resource',
  resourceId: 'resourceId',
  sortIndex: 'sortIndex'
} as const

export type CustomResourceScalarFieldEnum = (typeof CustomResourceScalarFieldEnum)[keyof typeof CustomResourceScalarFieldEnum]


export const CampaignScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  customerContext: 'customerContext',
  startedAt: 'startedAt'
} as const

export type CampaignScalarFieldEnum = (typeof CampaignScalarFieldEnum)[keyof typeof CampaignScalarFieldEnum]


export const CampaignGoalScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  name: 'name',
  context: 'context',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CampaignGoalScalarFieldEnum = (typeof CampaignGoalScalarFieldEnum)[keyof typeof CampaignGoalScalarFieldEnum]


export const CampaignParticipantScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  customerId: 'customerId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stagedMessage: 'stagedMessage'
} as const

export type CampaignParticipantScalarFieldEnum = (typeof CampaignParticipantScalarFieldEnum)[keyof typeof CampaignParticipantScalarFieldEnum]


export const MetafieldScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  customResourceModelId: 'customResourceModelId',
  resource: 'resource',
  workplaceId: 'workplaceId',
  locked: 'locked',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  definitionHandle: 'definitionHandle',
  label: 'label',
  memberId: 'memberId',
  defaultValue: 'defaultValue',
  helpText: 'helpText',
  required: 'required',
  validationMessages: 'validationMessages',
  unique: 'unique',
  core: 'core',
  filterOptionsBy: 'filterOptionsBy',
  defaultMetafieldDefinitionOptionId: 'defaultMetafieldDefinitionOptionId'
} as const

export type MetafieldScalarFieldEnum = (typeof MetafieldScalarFieldEnum)[keyof typeof MetafieldScalarFieldEnum]


export const MetafieldValueScalarFieldEnum = {
  id: 'id',
  customResourceModelId: 'customResourceModelId',
  customResourceId: 'customResourceId',
  resource: 'resource',
  workplaceId: 'workplaceId',
  value: 'value',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metafieldId: 'metafieldId',
  object: 'object',
  resourceId: 'resourceId',
  metafieldDefinitionOptionId: 'metafieldDefinitionOptionId'
} as const

export type MetafieldValueScalarFieldEnum = (typeof MetafieldValueScalarFieldEnum)[keyof typeof MetafieldValueScalarFieldEnum]


export const MetafieldDefinitionScalarFieldEnum = {
  handle: 'handle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inputType: 'inputType',
  params: 'params',
  workplaceId: 'workplaceId',
  lazyLoading: 'lazyLoading',
  resource: 'resource',
  dataType: 'dataType'
} as const

export type MetafieldDefinitionScalarFieldEnum = (typeof MetafieldDefinitionScalarFieldEnum)[keyof typeof MetafieldDefinitionScalarFieldEnum]


export const MetafieldDefinitionOptionScalarFieldEnum = {
  metafieldDefinitionHandle: 'metafieldDefinitionHandle',
  value: 'value',
  color: 'color',
  createdAt: 'createdAt',
  description: 'description',
  imageUrl: 'imageUrl',
  label: 'label',
  updatedAt: 'updatedAt',
  object: 'object',
  groupBy: 'groupBy',
  lazyLoading: 'lazyLoading',
  id: 'id'
} as const

export type MetafieldDefinitionOptionScalarFieldEnum = (typeof MetafieldDefinitionOptionScalarFieldEnum)[keyof typeof MetafieldDefinitionOptionScalarFieldEnum]


export const InputTypeScalarFieldEnum = {
  handle: 'handle',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InputTypeScalarFieldEnum = (typeof InputTypeScalarFieldEnum)[keyof typeof InputTypeScalarFieldEnum]


export const ImportScalarFieldEnum = {
  id: 'id',
  fileId: 'fileId',
  modelId: 'modelId',
  status: 'status',
  totalRows: 'totalRows',
  processedRows: 'processedRows',
  completedRows: 'completedRows',
  failedRows: 'failedRows',
  skippedRows: 'skippedRows',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  failedAt: 'failedAt',
  error: 'error',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  importMode: 'importMode',
  instanceId: 'instanceId',
  matchOnFieldId: 'matchOnFieldId',
  lastProcessedCursor: 'lastProcessedCursor',
  associationRules: 'associationRules'
} as const

export type ImportScalarFieldEnum = (typeof ImportScalarFieldEnum)[keyof typeof ImportScalarFieldEnum]


export const ImportRowScalarFieldEnum = {
  id: 'id',
  importId: 'importId',
  rowNumber: 'rowNumber',
  csvData: 'csvData',
  status: 'status',
  processedAt: 'processedAt',
  error: 'error',
  validationErrors: 'validationErrors',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  action: 'action',
  info: 'info',
  instanceId: 'instanceId'
} as const

export type ImportRowScalarFieldEnum = (typeof ImportRowScalarFieldEnum)[keyof typeof ImportRowScalarFieldEnum]


export const MigrationScalarFieldEnum = {
  id: 'id',
  key: 'key',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  cancelledAt: 'cancelledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MigrationScalarFieldEnum = (typeof MigrationScalarFieldEnum)[keyof typeof MigrationScalarFieldEnum]


export const WorkplaceMigrationScalarFieldEnum = {
  id: 'id',
  migrationId: 'migrationId',
  workplaceId: 'workplaceId',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WorkplaceMigrationScalarFieldEnum = (typeof WorkplaceMigrationScalarFieldEnum)[keyof typeof WorkplaceMigrationScalarFieldEnum]


export const LlmProviderScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  displayName: 'displayName',
  baseUrl: 'baseUrl',
  envSchema: 'envSchema',
  system: 'system',
  isActive: 'isActive',
  workplaceId: 'workplaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LlmProviderScalarFieldEnum = (typeof LlmProviderScalarFieldEnum)[keyof typeof LlmProviderScalarFieldEnum]


export const LlmModelScalarFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  name: 'name',
  description: 'description',
  contextWindow: 'contextWindow',
  inputPricePerMillion: 'inputPricePerMillion',
  outputPricePerMillion: 'outputPricePerMillion',
  capabilities: 'capabilities',
  isActive: 'isActive',
  isDefault: 'isDefault',
  sortOrder: 'sortOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  llmProviderId: 'llmProviderId'
} as const

export type LlmModelScalarFieldEnum = (typeof LlmModelScalarFieldEnum)[keyof typeof LlmModelScalarFieldEnum]


export const LlmUsageScalarFieldEnum = {
  id: 'id',
  llmModelId: 'llmModelId',
  workplaceId: 'workplaceId',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  estimatedCost: 'estimatedCost',
  source: 'source',
  referenceId: 'referenceId',
  referenceType: 'referenceType',
  createdAt: 'createdAt',
  agentRunId: 'agentRunId'
} as const

export type LlmUsageScalarFieldEnum = (typeof LlmUsageScalarFieldEnum)[keyof typeof LlmUsageScalarFieldEnum]


export const ProvisionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  appVersionId: 'appVersionId',
  executableId: 'executableId',
  previousExecutableId: 'previousExecutableId',
  temporalWorkflowId: 'temporalWorkflowId',
  currentStep: 'currentStep',
  steps: 'steps',
  errorMessage: 'errorMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt',
  pendingMigration: 'pendingMigration'
} as const

export type ProvisionScalarFieldEnum = (typeof ProvisionScalarFieldEnum)[keyof typeof ProvisionScalarFieldEnum]


export const ReportDefinitionScalarFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  description: 'description',
  templateYaml: 'templateYaml',
  globalArguments: 'globalArguments',
  version: 'version',
  status: 'status',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReportDefinitionScalarFieldEnum = (typeof ReportDefinitionScalarFieldEnum)[keyof typeof ReportDefinitionScalarFieldEnum]


export const CRMMigrationScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  source: 'source',
  sourceId: 'sourceId',
  status: 'status',
  requiresApproval: 'requiresApproval',
  approvedBy: 'approvedBy',
  approvedAt: 'approvedAt',
  deniedBy: 'deniedBy',
  deniedAt: 'deniedAt',
  denyReason: 'denyReason',
  expiresAt: 'expiresAt',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  errorMessage: 'errorMessage',
  rolledBackAt: 'rolledBackAt',
  rolledBackBy: 'rolledBackBy',
  rollbackReason: 'rollbackReason',
  batchId: 'batchId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy'
} as const

export type CRMMigrationScalarFieldEnum = (typeof CRMMigrationScalarFieldEnum)[keyof typeof CRMMigrationScalarFieldEnum]


export const CRMOperationScalarFieldEnum = {
  id: 'id',
  migrationId: 'migrationId',
  operationType: 'operationType',
  resourceType: 'resourceType',
  resourceId: 'resourceId',
  resourceHandle: 'resourceHandle',
  beforeState: 'beforeState',
  afterState: 'afterState',
  payload: 'payload',
  isDestructive: 'isDestructive',
  impactSummary: 'impactSummary',
  affectedRecords: 'affectedRecords',
  status: 'status',
  executedAt: 'executedAt',
  errorMessage: 'errorMessage',
  sortOrder: 'sortOrder',
  createdAt: 'createdAt'
} as const

export type CRMOperationScalarFieldEnum = (typeof CRMOperationScalarFieldEnum)[keyof typeof CRMOperationScalarFieldEnum]


export const ThreadWorkflowRunScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workflowRunId: 'workflowRunId',
  handle: 'handle',
  status: 'status',
  startedByHookId: 'startedByHookId',
  config: 'config',
  sourceMessageId: 'sourceMessageId',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  cancelledAt: 'cancelledAt',
  cancelReason: 'cancelReason'
} as const

export type ThreadWorkflowRunScalarFieldEnum = (typeof ThreadWorkflowRunScalarFieldEnum)[keyof typeof ThreadWorkflowRunScalarFieldEnum]


export const ParticipantScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  kind: 'kind',
  contactId: 'contactId',
  memberId: 'memberId',
  agentId: 'agentId',
  contactAssociationId: 'contactAssociationId',
  displayName: 'displayName',
  avatarUrl: 'avatarUrl',
  externalId: 'externalId',
  appData: 'appData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  batchJobId: 'batchJobId',
  workflowId: 'workflowId',
  isWildcard: 'isWildcard'
} as const

export type ParticipantScalarFieldEnum = (typeof ParticipantScalarFieldEnum)[keyof typeof ParticipantScalarFieldEnum]


export const ThreadScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  parentId: 'parentId',
  sourceMessageId: 'sourceMessageId',
  title: 'title',
  status: 'status',
  kind: 'kind',
  unreadCount: 'unreadCount',
  pendingApprovalCount: 'pendingApprovalCount',
  lastMessageAt: 'lastMessageAt',
  lastActivityAt: 'lastActivityAt',
  lastActivityType: 'lastActivityType',
  externalId: 'externalId',
  appData: 'appData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSummarizedAt: 'lastSummarizedAt',
  lastSummarizedMsgId: 'lastSummarizedMsgId',
  ephemeral: 'ephemeral',
  sessionId: 'sessionId',
  expiresAt: 'expiresAt',
  pinnedAt: 'pinnedAt',
  communicationChannelId: 'communicationChannelId',
  routingAddress: 'routingAddress',
  routingParticipantId: 'routingParticipantId',
  channelAppData: 'channelAppData',
  isWildcardRouting: 'isWildcardRouting',
  routingPattern: 'routingPattern',
  routingPatternDisplay: 'routingPatternDisplay',
  isExclusiveFeed: 'isExclusiveFeed',
  lastSyncedAt: 'lastSyncedAt',
  syncStatus: 'syncStatus',
  lastCustomerMessageAt: 'lastCustomerMessageAt'
} as const

export type ThreadScalarFieldEnum = (typeof ThreadScalarFieldEnum)[keyof typeof ThreadScalarFieldEnum]


export const ThreadParticipantScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  participantId: 'participantId',
  role: 'role',
  visibility: 'visibility',
  notifyOnMessage: 'notifyOnMessage',
  joinedAt: 'joinedAt',
  leftAt: 'leftAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lockedAgentVersionId: 'lockedAgentVersionId',
  versionLockedAt: 'versionLockedAt',
  previousVersionId: 'previousVersionId',
  activeAgentRunId: 'activeAgentRunId',
  lockedWorkflowVersionId: 'lockedWorkflowVersionId',
  workflowVersionLockedAt: 'workflowVersionLockedAt'
} as const

export type ThreadParticipantScalarFieldEnum = (typeof ThreadParticipantScalarFieldEnum)[keyof typeof ThreadParticipantScalarFieldEnum]


export const ScheduledEventScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  agentId: 'agentId',
  scheduledAt: 'scheduledAt',
  eventType: 'eventType',
  payload: 'payload',
  status: 'status',
  firedAt: 'firedAt',
  cancelledAt: 'cancelledAt',
  cancelledBy: 'cancelledBy',
  reason: 'reason',
  createdAt: 'createdAt'
} as const

export type ScheduledEventScalarFieldEnum = (typeof ScheduledEventScalarFieldEnum)[keyof typeof ScheduledEventScalarFieldEnum]


export const ScheduledMessageScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  senderId: 'senderId',
  content: 'content',
  contentType: 'contentType',
  scheduledAt: 'scheduledAt',
  status: 'status',
  cancelOnActivity: 'cancelOnActivity',
  sentAt: 'sentAt',
  cancelledAt: 'cancelledAt',
  cancelledReason: 'cancelledReason',
  createdMessageId: 'createdMessageId',
  requiresApproval: 'requiresApproval',
  approvedAt: 'approvedAt',
  approvedBy: 'approvedBy',
  approvalBlockId: 'approvalBlockId',
  batchJobId: 'batchJobId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScheduledMessageScalarFieldEnum = (typeof ScheduledMessageScalarFieldEnum)[keyof typeof ScheduledMessageScalarFieldEnum]


export const ThreadMessageScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  senderId: 'senderId',
  content: 'content',
  contentType: 'contentType',
  contentRaw: 'contentRaw',
  contentFormat: 'contentFormat',
  aiGenerated: 'aiGenerated',
  sentAt: 'sentAt',
  sendStatus: 'sendStatus',
  externalId: 'externalId',
  appData: 'appData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  deletedBy: 'deletedBy',
  isPinned: 'isPinned',
  replyToMessageId: 'replyToMessageId',
  agentRunId: 'agentRunId',
  workflowRunId: 'workflowRunId',
  contentStructured: 'contentStructured',
  metadata: 'metadata',
  batchJobId: 'batchJobId',
  callSessionId: 'callSessionId'
} as const

export type ThreadMessageScalarFieldEnum = (typeof ThreadMessageScalarFieldEnum)[keyof typeof ThreadMessageScalarFieldEnum]


export const ThreadMessageAttachmentScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  fileId: 'fileId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ThreadMessageAttachmentScalarFieldEnum = (typeof ThreadMessageAttachmentScalarFieldEnum)[keyof typeof ThreadMessageAttachmentScalarFieldEnum]


export const MessageOutboxScalarFieldEnum = {
  id: 'id',
  status: 'status',
  threadId: 'threadId',
  messageId: 'messageId',
  appInstallationId: 'appInstallationId',
  channelId: 'channelId',
  sendToolName: 'sendToolName',
  sendBatchToolName: 'sendBatchToolName',
  batchJobId: 'batchJobId',
  routingType: 'routingType',
  routingAddress: 'routingAddress',
  routingParticipantId: 'routingParticipantId',
  externalGroupId: 'externalGroupId',
  sendPayload: 'sendPayload',
  attempts: 'attempts',
  maxAttempts: 'maxAttempts',
  lastError: 'lastError',
  nextRetryAt: 'nextRetryAt',
  usedInvokeUrl: 'usedInvokeUrl',
  sentAt: 'sentAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MessageOutboxScalarFieldEnum = (typeof MessageOutboxScalarFieldEnum)[keyof typeof MessageOutboxScalarFieldEnum]


export const MessageInboxScalarFieldEnum = {
  id: 'id',
  status: 'status',
  messageId: 'messageId',
  communicationChannelId: 'communicationChannelId',
  senderIdentifierValue: 'senderIdentifierValue',
  receiverIdentifierValue: 'receiverIdentifierValue',
  messageContent: 'messageContent',
  messageContentRaw: 'messageContentRaw',
  messageTitle: 'messageTitle',
  externalMessageId: 'externalMessageId',
  attachments: 'attachments',
  expectedAttachmentCount: 'expectedAttachmentCount',
  messageReceivedEmittedAt: 'messageReceivedEmittedAt',
  senderMeta: 'senderMeta',
  groupMeta: 'groupMeta',
  attempts: 'attempts',
  lastError: 'lastError',
  threadId: 'threadId',
  contactId: 'contactId',
  createdAt: 'createdAt',
  processedAt: 'processedAt'
} as const

export type MessageInboxScalarFieldEnum = (typeof MessageInboxScalarFieldEnum)[keyof typeof MessageInboxScalarFieldEnum]


export const EventScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  type: 'type',
  payload: 'payload',
  resourceType: 'resourceType',
  resourceId: 'resourceId',
  status: 'status',
  processedAt: 'processedAt',
  error: 'error',
  retryCount: 'retryCount',
  claimedAt: 'claimedAt',
  emittedBy: 'emittedBy',
  createdAt: 'createdAt'
} as const

export type EventScalarFieldEnum = (typeof EventScalarFieldEnum)[keyof typeof EventScalarFieldEnum]


export const EventSubscriptionScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  agentId: 'agentId',
  triggerId: 'triggerId',
  eventType: 'eventType',
  action: 'action',
  condition: 'condition',
  description: 'description',
  isEnabled: 'isEnabled',
  inputMappings: 'inputMappings',
  matchConfig: 'matchConfig',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EventSubscriptionScalarFieldEnum = (typeof EventSubscriptionScalarFieldEnum)[keyof typeof EventSubscriptionScalarFieldEnum]


export const ThreadBlockScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  kind: 'kind',
  sequence: 'sequence',
  participantId: 'participantId',
  status: 'status',
  content: 'content',
  contentStructured: 'contentStructured',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  parentBlockId: 'parentBlockId',
  messageId: 'messageId',
  agentRunId: 'agentRunId',
  workflowRunId: 'workflowRunId',
  subThreadId: 'subThreadId',
  threadLinkId: 'threadLinkId',
  callSessionId: 'callSessionId'
} as const

export type ThreadBlockScalarFieldEnum = (typeof ThreadBlockScalarFieldEnum)[keyof typeof ThreadBlockScalarFieldEnum]


export const ThreadReadCursorScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  threadParticipantId: 'threadParticipantId',
  lastReadMessageId: 'lastReadMessageId',
  lastReadAt: 'lastReadAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ThreadReadCursorScalarFieldEnum = (typeof ThreadReadCursorScalarFieldEnum)[keyof typeof ThreadReadCursorScalarFieldEnum]


export const ThreadContextScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  kind: 'kind',
  instanceId: 'instanceId',
  linkedThreadId: 'linkedThreadId',
  documentUrl: 'documentUrl',
  role: 'role',
  reason: 'reason',
  externalId: 'externalId',
  appData: 'appData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  handle: 'handle'
} as const

export type ThreadContextScalarFieldEnum = (typeof ThreadContextScalarFieldEnum)[keyof typeof ThreadContextScalarFieldEnum]


export const ThreadLinkScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  sourceThreadId: 'sourceThreadId',
  targetThreadId: 'targetThreadId',
  initiatorId: 'initiatorId',
  role: 'role',
  sourceMessageId: 'sourceMessageId',
  reason: 'reason',
  workflowRunId: 'workflowRunId',
  workflowRunStepId: 'workflowRunStepId',
  agentRunId: 'agentRunId',
  createdBy: 'createdBy',
  createdByMemberId: 'createdByMemberId',
  status: 'status',
  purpose: 'purpose',
  contextSummary: 'contextSummary',
  resolvedAt: 'resolvedAt',
  resolution: 'resolution',
  timeoutAt: 'timeoutAt',
  lastCheckedAt: 'lastCheckedAt',
  checkCount: 'checkCount',
  maxChecks: 'maxChecks',
  retryDelayMs: 'retryDelayMs',
  linkedAt: 'linkedAt',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ThreadLinkScalarFieldEnum = (typeof ThreadLinkScalarFieldEnum)[keyof typeof ThreadLinkScalarFieldEnum]


export const ThreadTopicScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  name: 'name',
  handle: 'handle',
  description: 'description',
  color: 'color',
  icon: 'icon',
  isAutoGenerated: 'isAutoGenerated',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ThreadTopicScalarFieldEnum = (typeof ThreadTopicScalarFieldEnum)[keyof typeof ThreadTopicScalarFieldEnum]


export const MessageTopicScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  topicId: 'topicId',
  relevance: 'relevance',
  assignedBy: 'assignedBy',
  assignedAt: 'assignedAt'
} as const

export type MessageTopicScalarFieldEnum = (typeof MessageTopicScalarFieldEnum)[keyof typeof MessageTopicScalarFieldEnum]


export const MessageTagScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  name: 'name',
  handle: 'handle',
  color: 'color',
  kind: 'kind',
  createdAt: 'createdAt'
} as const

export type MessageTagScalarFieldEnum = (typeof MessageTagScalarFieldEnum)[keyof typeof MessageTagScalarFieldEnum]


export const MessageTagAssignmentScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  tagId: 'tagId',
  assignedBy: 'assignedBy',
  assignedAt: 'assignedAt'
} as const

export type MessageTagAssignmentScalarFieldEnum = (typeof MessageTagAssignmentScalarFieldEnum)[keyof typeof MessageTagAssignmentScalarFieldEnum]


export const DecisionTypeScalarFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  handle: 'handle',
  name: 'name',
  description: 'description',
  category: 'category',
  automationEnabled: 'automationEnabled',
  workflowId: 'workflowId',
  extractionHints: 'extractionHints',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DecisionTypeScalarFieldEnum = (typeof DecisionTypeScalarFieldEnum)[keyof typeof DecisionTypeScalarFieldEnum]


export const ThreadDecisionScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  title: 'title',
  summary: 'summary',
  sourceMessageIds: 'sourceMessageIds',
  decisionTypeId: 'decisionTypeId',
  status: 'status',
  madeBy: 'madeBy',
  madeAt: 'madeAt',
  expiresAt: 'expiresAt',
  topicId: 'topicId',
  confidence: 'confidence',
  automationTriggered: 'automationTriggered',
  automationRunId: 'automationRunId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ThreadDecisionScalarFieldEnum = (typeof ThreadDecisionScalarFieldEnum)[keyof typeof ThreadDecisionScalarFieldEnum]


export const ThreadSummaryScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  summary: 'summary',
  kind: 'kind',
  fromMessageId: 'fromMessageId',
  toMessageId: 'toMessageId',
  fromDate: 'fromDate',
  toDate: 'toDate',
  topicId: 'topicId',
  messageCount: 'messageCount',
  createdAt: 'createdAt'
} as const

export type ThreadSummaryScalarFieldEnum = (typeof ThreadSummaryScalarFieldEnum)[keyof typeof ThreadSummaryScalarFieldEnum]


export const MessageEmbeddingScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  workplaceId: 'workplaceId',
  model: 'model',
  dimensions: 'dimensions',
  embeddedContent: 'embeddedContent',
  createdAt: 'createdAt'
} as const

export type MessageEmbeddingScalarFieldEnum = (typeof MessageEmbeddingScalarFieldEnum)[keyof typeof MessageEmbeddingScalarFieldEnum]


export const CallSessionScalarFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  kind: 'kind',
  communicationChannelId: 'communicationChannelId',
  direction: 'direction',
  status: 'status',
  externalStatus: 'externalStatus',
  startedAt: 'startedAt',
  answeredAt: 'answeredAt',
  endedAt: 'endedAt',
  scheduledAt: 'scheduledAt',
  duration: 'duration',
  initiatorId: 'initiatorId',
  initiatorCallParticipantId: 'initiatorCallParticipantId',
  fromNumber: 'fromNumber',
  toNumber: 'toNumber',
  forwardedToNumber: 'forwardedToNumber',
  externalId: 'externalId',
  appData: 'appData',
  joinUrl: 'joinUrl',
  isRecorded: 'isRecorded',
  recordingUrl: 'recordingUrl',
  recordingSid: 'recordingSid',
  transcriptionEngine: 'transcriptionEngine',
  transcriptionSid: 'transcriptionSid',
  summary: 'summary',
  summaryMessageId: 'summaryMessageId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CallSessionScalarFieldEnum = (typeof CallSessionScalarFieldEnum)[keyof typeof CallSessionScalarFieldEnum]


export const CallRecordingChunkScalarFieldEnum = {
  id: 'id',
  callSessionId: 'callSessionId',
  segmentIndex: 'segmentIndex',
  chunkIndex: 'chunkIndex',
  fileId: 'fileId',
  mimeType: 'mimeType',
  byteLength: 'byteLength',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CallRecordingChunkScalarFieldEnum = (typeof CallRecordingChunkScalarFieldEnum)[keyof typeof CallRecordingChunkScalarFieldEnum]


export const CallParticipantScalarFieldEnum = {
  id: 'id',
  callSessionId: 'callSessionId',
  threadParticipantId: 'threadParticipantId',
  displayName: 'displayName',
  status: 'status',
  invitedAt: 'invitedAt',
  joinedAt: 'joinedAt',
  leftAt: 'leftAt',
  isMuted: 'isMuted',
  isVideoOn: 'isVideoOn',
  isScreenSharing: 'isScreenSharing',
  dialInNumber: 'dialInNumber',
  phoneNumber: 'phoneNumber',
  trackLabel: 'trackLabel',
  externalId: 'externalId',
  appData: 'appData'
} as const

export type CallParticipantScalarFieldEnum = (typeof CallParticipantScalarFieldEnum)[keyof typeof CallParticipantScalarFieldEnum]


export const MessageReactionScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  participantId: 'participantId',
  emoji: 'emoji',
  emojiName: 'emojiName',
  externalId: 'externalId',
  appData: 'appData',
  createdAt: 'createdAt'
} as const

export type MessageReactionScalarFieldEnum = (typeof MessageReactionScalarFieldEnum)[keyof typeof MessageReactionScalarFieldEnum]


export const MessageMentionScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  participantId: 'participantId',
  startIndex: 'startIndex',
  endIndex: 'endIndex',
  kind: 'kind',
  externalId: 'externalId',
  appData: 'appData'
} as const

export type MessageMentionScalarFieldEnum = (typeof MessageMentionScalarFieldEnum)[keyof typeof MessageMentionScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: 'JsonNull'
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const WorkplaceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  subdomain: 'subdomain',
  clerkOrganizationId: 'clerkOrganizationId',
  phone: 'phone',
  stripeAccountId: 'stripeAccountId',
  profileImageUrl: 'profileImageUrl',
  stripeAccountUrl: 'stripeAccountUrl',
  agentPersona: 'agentPersona',
  businessInformation: 'businessInformation'
} as const

export type WorkplaceOrderByRelevanceFieldEnum = (typeof WorkplaceOrderByRelevanceFieldEnum)[keyof typeof WorkplaceOrderByRelevanceFieldEnum]


export const InstanceOrderByRelevanceFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  workplaceId: 'workplaceId',
  label: 'label',
  image: 'image',
  imageSeed: 'imageSeed',
  appInstallationId: 'appInstallationId'
} as const

export type InstanceOrderByRelevanceFieldEnum = (typeof InstanceOrderByRelevanceFieldEnum)[keyof typeof InstanceOrderByRelevanceFieldEnum]


export const JsonNullValueFilter = {
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const InstanceActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  instanceId: 'instanceId',
  workplaceId: 'workplaceId'
} as const

export type InstanceActivityOrderByRelevanceFieldEnum = (typeof InstanceActivityOrderByRelevanceFieldEnum)[keyof typeof InstanceActivityOrderByRelevanceFieldEnum]


export const RecordActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  instanceId: 'instanceId',
  instanceActivityId: 'instanceActivityId'
} as const

export type RecordActivityOrderByRelevanceFieldEnum = (typeof RecordActivityOrderByRelevanceFieldEnum)[keyof typeof RecordActivityOrderByRelevanceFieldEnum]


export const RecordOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  instanceId: 'instanceId',
  workplaceId: 'workplaceId',
  communicationChannelSubscriptionId: 'communicationChannelSubscriptionId'
} as const

export type RecordOrderByRelevanceFieldEnum = (typeof RecordOrderByRelevanceFieldEnum)[keyof typeof RecordOrderByRelevanceFieldEnum]


export const RecordUniqueValueOrderByRelevanceFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  fieldId: 'fieldId',
  workplaceId: 'workplaceId',
  value: 'value',
  instanceId: 'instanceId'
} as const

export type RecordUniqueValueOrderByRelevanceFieldEnum = (typeof RecordUniqueValueOrderByRelevanceFieldEnum)[keyof typeof RecordUniqueValueOrderByRelevanceFieldEnum]


export const RecordSelectedOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  recordId: 'recordId',
  optionId: 'optionId'
} as const

export type RecordSelectedOptionOrderByRelevanceFieldEnum = (typeof RecordSelectedOptionOrderByRelevanceFieldEnum)[keyof typeof RecordSelectedOptionOrderByRelevanceFieldEnum]


export const FieldDefaultOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  optionId: 'optionId'
} as const

export type FieldDefaultOptionOrderByRelevanceFieldEnum = (typeof FieldDefaultOptionOrderByRelevanceFieldEnum)[keyof typeof FieldDefaultOptionOrderByRelevanceFieldEnum]


export const RelationshipRecordOrderByRelevanceFieldEnum = {
  id: 'id',
  sourceInstanceId: 'sourceInstanceId',
  targetInstanceId: 'targetInstanceId',
  workplaceId: 'workplaceId',
  relationshipLinkId: 'relationshipLinkId'
} as const

export type RelationshipRecordOrderByRelevanceFieldEnum = (typeof RelationshipRecordOrderByRelevanceFieldEnum)[keyof typeof RelationshipRecordOrderByRelevanceFieldEnum]


export const PageOrderByRelevanceFieldEnum = {
  id: 'id',
  path: 'path',
  parentPageId: 'parentPageId',
  title: 'title',
  icon: 'icon',
  modelId: 'modelId',
  workplaceId: 'workplaceId',
  memberId: 'memberId'
} as const

export type PageOrderByRelevanceFieldEnum = (typeof PageOrderByRelevanceFieldEnum)[keyof typeof PageOrderByRelevanceFieldEnum]


export const MemberNavigationItemOrderByRelevanceFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  pageId: 'pageId',
  url: 'url',
  label: 'label',
  icon: 'icon',
  parentId: 'parentId'
} as const

export type MemberNavigationItemOrderByRelevanceFieldEnum = (typeof MemberNavigationItemOrderByRelevanceFieldEnum)[keyof typeof MemberNavigationItemOrderByRelevanceFieldEnum]


export const NavigationItemOrderByRelevanceFieldEnum = {
  id: 'id',
  url: 'url',
  label: 'label',
  icon: 'icon',
  parentId: 'parentId',
  pageId: 'pageId',
  workplaceId: 'workplaceId'
} as const

export type NavigationItemOrderByRelevanceFieldEnum = (typeof NavigationItemOrderByRelevanceFieldEnum)[keyof typeof NavigationItemOrderByRelevanceFieldEnum]


export const BlockOrderByRelevanceFieldEnum = {
  id: 'id',
  pageId: 'pageId',
  title: 'title',
  modelId: 'modelId',
  relationshipLinkId: 'relationshipLinkId'
} as const

export type BlockOrderByRelevanceFieldEnum = (typeof BlockOrderByRelevanceFieldEnum)[keyof typeof BlockOrderByRelevanceFieldEnum]


export const ModelOrderByRelevanceFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  labelTemplate: 'labelTemplate',
  workplaceId: 'workplaceId',
  handlePlural: 'handlePlural',
  namePlural: 'namePlural',
  description: 'description',
  imageSeedTemplate: 'imageSeedTemplate'
} as const

export type ModelOrderByRelevanceFieldEnum = (typeof ModelOrderByRelevanceFieldEnum)[keyof typeof ModelOrderByRelevanceFieldEnum]


export const FieldOrderByRelevanceFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  definitionId: 'definitionId',
  description: 'description',
  handle: 'handle',
  workplaceId: 'workplaceId',
  label: 'label',
  relationshipLinkId: 'relationshipLinkId',
  sectionId: 'sectionId'
} as const

export type FieldOrderByRelevanceFieldEnum = (typeof FieldOrderByRelevanceFieldEnum)[keyof typeof FieldOrderByRelevanceFieldEnum]


export const FieldSectionOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  handle: 'handle',
  name: 'name'
} as const

export type FieldSectionOrderByRelevanceFieldEnum = (typeof FieldSectionOrderByRelevanceFieldEnum)[keyof typeof FieldSectionOrderByRelevanceFieldEnum]


export const DataNormalizationOrderByRelevanceFieldEnum = {
  name: 'name',
  description: 'description',
  handle: 'handle',
  icon: 'icon'
} as const

export type DataNormalizationOrderByRelevanceFieldEnum = (typeof DataNormalizationOrderByRelevanceFieldEnum)[keyof typeof DataNormalizationOrderByRelevanceFieldEnum]


export const FieldDefinitionNormalizationOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldDefinitionId: 'fieldDefinitionId',
  handle: 'handle'
} as const

export type FieldDefinitionNormalizationOrderByRelevanceFieldEnum = (typeof FieldDefinitionNormalizationOrderByRelevanceFieldEnum)[keyof typeof FieldDefinitionNormalizationOrderByRelevanceFieldEnum]


export const FieldDefinitionOrderByRelevanceFieldEnum = {
  id: 'id',
  handle: 'handle',
  regexPattern: 'regexPattern',
  workplaceId: 'workplaceId'
} as const

export type FieldDefinitionOrderByRelevanceFieldEnum = (typeof FieldDefinitionOrderByRelevanceFieldEnum)[keyof typeof FieldDefinitionOrderByRelevanceFieldEnum]


export const FieldDefinitionOptionOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldDefinitionId: 'fieldDefinitionId',
  label: 'label',
  value: 'value',
  icon: 'icon',
  color: 'color'
} as const

export type FieldDefinitionOptionOrderByRelevanceFieldEnum = (typeof FieldDefinitionOptionOrderByRelevanceFieldEnum)[keyof typeof FieldDefinitionOptionOrderByRelevanceFieldEnum]


export const RelationshipOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId'
} as const

export type RelationshipOrderByRelevanceFieldEnum = (typeof RelationshipOrderByRelevanceFieldEnum)[keyof typeof RelationshipOrderByRelevanceFieldEnum]


export const RelationshipLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  relationshipId: 'relationshipId',
  targetModelId: 'targetModelId',
  sourceModelId: 'sourceModelId'
} as const

export type RelationshipLinkOrderByRelevanceFieldEnum = (typeof RelationshipLinkOrderByRelevanceFieldEnum)[keyof typeof RelationshipLinkOrderByRelevanceFieldEnum]


export const SettingOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  workplaceId: 'workplaceId'
} as const

export type SettingOrderByRelevanceFieldEnum = (typeof SettingOrderByRelevanceFieldEnum)[keyof typeof SettingOrderByRelevanceFieldEnum]


export const TaxRateOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  country: 'country'
} as const

export type TaxRateOrderByRelevanceFieldEnum = (typeof TaxRateOrderByRelevanceFieldEnum)[keyof typeof TaxRateOrderByRelevanceFieldEnum]


export const TaxLineOrderByRelevanceFieldEnum = {
  id: 'id',
  lineId: 'lineId',
  invoiceId: 'invoiceId',
  invoiceLineId: 'invoiceLineId',
  orderId: 'orderId',
  name: 'name',
  taxRateId: 'taxRateId',
  taxAmountId: 'taxAmountId',
  workplaceId: 'workplaceId',
  refundId: 'refundId'
} as const

export type TaxLineOrderByRelevanceFieldEnum = (typeof TaxLineOrderByRelevanceFieldEnum)[keyof typeof TaxLineOrderByRelevanceFieldEnum]


export const CheckoutOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  email: 'email',
  phone: 'phone',
  note: 'note',
  currency: 'currency',
  draftOrderId: 'draftOrderId',
  stripeCheckoutId: 'stripeCheckoutId',
  invoiceId: 'invoiceId',
  orderId: 'orderId',
  stripeClientSecret: 'stripeClientSecret',
  token: 'token',
  firstName: 'firstName',
  lastName: 'lastName'
} as const

export type CheckoutOrderByRelevanceFieldEnum = (typeof CheckoutOrderByRelevanceFieldEnum)[keyof typeof CheckoutOrderByRelevanceFieldEnum]


export const AdmissionOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  lineId: 'lineId',
  dependantLineAssignmentId: 'dependantLineAssignmentId',
  calculatedPriceId: 'calculatedPriceId',
  dependantId: 'dependantId',
  serviceId: 'serviceId',
  sessionId: 'sessionId'
} as const

export type AdmissionOrderByRelevanceFieldEnum = (typeof AdmissionOrderByRelevanceFieldEnum)[keyof typeof AdmissionOrderByRelevanceFieldEnum]


export const DependantLineAssignmentOrderByRelevanceFieldEnum = {
  id: 'id',
  lineId: 'lineId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  dependantId: 'dependantId'
} as const

export type DependantLineAssignmentOrderByRelevanceFieldEnum = (typeof DependantLineAssignmentOrderByRelevanceFieldEnum)[keyof typeof DependantLineAssignmentOrderByRelevanceFieldEnum]


export const LineOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  orderId: 'orderId',
  draftOrderId: 'draftOrderId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  serviceId: 'serviceId',
  priceId: 'priceId',
  rateId: 'rateId'
} as const

export type LineOrderByRelevanceFieldEnum = (typeof LineOrderByRelevanceFieldEnum)[keyof typeof LineOrderByRelevanceFieldEnum]


export const OrderOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  memberId: 'memberId',
  draftOrderId: 'draftOrderId',
  currency: 'currency',
  name: 'name',
  runningSubtotalId: 'runningSubtotalId',
  runningTotalId: 'runningTotalId',
  runningTotalTaxId: 'runningTotalTaxId',
  totalPaidId: 'totalPaidId',
  pendingSubtotalId: 'pendingSubtotalId',
  pendingTotalId: 'pendingTotalId',
  pendingTotalTaxId: 'pendingTotalTaxId',
  email: 'email',
  defaultLocationId: 'defaultLocationId',
  totalRefundedId: 'totalRefundedId'
} as const

export type OrderOrderByRelevanceFieldEnum = (typeof OrderOrderByRelevanceFieldEnum)[keyof typeof OrderOrderByRelevanceFieldEnum]


export const DraftOrderOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  memberId: 'memberId',
  name: 'name',
  runningSubtotalId: 'runningSubtotalId',
  runningTotalId: 'runningTotalId',
  runningTotalTaxId: 'runningTotalTaxId',
  currency: 'currency',
  email: 'email',
  locationId: 'locationId'
} as const

export type DraftOrderOrderByRelevanceFieldEnum = (typeof DraftOrderOrderByRelevanceFieldEnum)[keyof typeof DraftOrderOrderByRelevanceFieldEnum]


export const TerminalReaderOrderByRelevanceFieldEnum = {
  id: 'id',
  stripeReaderId: 'stripeReaderId',
  workplaceId: 'workplaceId',
  locationId: 'locationId',
  serialNumber: 'serialNumber',
  deviceType: 'deviceType',
  deviceSWVersion: 'deviceSWVersion',
  name: 'name',
  draftOrderId: 'draftOrderId',
  orderId: 'orderId',
  stripePaymentIntentId: 'stripePaymentIntentId'
} as const

export type TerminalReaderOrderByRelevanceFieldEnum = (typeof TerminalReaderOrderByRelevanceFieldEnum)[keyof typeof TerminalReaderOrderByRelevanceFieldEnum]


export const LocationOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  addressId: 'addressId',
  memberId: 'memberId',
  timezone: 'timezone',
  stripeLocationId: 'stripeLocationId'
} as const

export type LocationOrderByRelevanceFieldEnum = (typeof LocationOrderByRelevanceFieldEnum)[keyof typeof LocationOrderByRelevanceFieldEnum]


export const SpaceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  workplaceId: 'workplaceId',
  locationId: 'locationId',
  color: 'color',
  memberId: 'memberId'
} as const

export type SpaceOrderByRelevanceFieldEnum = (typeof SpaceOrderByRelevanceFieldEnum)[keyof typeof SpaceOrderByRelevanceFieldEnum]


export const FileOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  mimeType: 'mimeType',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  name: 'name',
  publicUrl: 'publicUrl',
  lastUpdatedById: 'lastUpdatedById'
} as const

export type FileOrderByRelevanceFieldEnum = (typeof FileOrderByRelevanceFieldEnum)[keyof typeof FileOrderByRelevanceFieldEnum]


export const TransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  invoiceId: 'invoiceId',
  amountId: 'amountId',
  orderId: 'orderId',
  stripeChargeId: 'stripeChargeId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripeRefundId: 'stripeRefundId',
  locationId: 'locationId',
  refundId: 'refundId'
} as const

export type TransactionOrderByRelevanceFieldEnum = (typeof TransactionOrderByRelevanceFieldEnum)[keyof typeof TransactionOrderByRelevanceFieldEnum]


export const InvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  hostedInvoiceUrl: 'hostedInvoiceUrl',
  totalId: 'totalId',
  totalTaxId: 'totalTaxId',
  workplaceId: 'workplaceId',
  stripeInvoiceId: 'stripeInvoiceId',
  currency: 'currency',
  email: 'email',
  name: 'name',
  note: 'note',
  phone: 'phone',
  subtotalId: 'subtotalId',
  totalNetId: 'totalNetId',
  totalRefundedId: 'totalRefundedId',
  memberId: 'memberId',
  orderId: 'orderId',
  totalPaidId: 'totalPaidId',
  locationId: 'locationId'
} as const

export type InvoiceOrderByRelevanceFieldEnum = (typeof InvoiceOrderByRelevanceFieldEnum)[keyof typeof InvoiceOrderByRelevanceFieldEnum]


export const InvoiceLineOrderByRelevanceFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  description: 'description',
  workplaceId: 'workplaceId',
  productVariantId: 'productVariantId',
  checkoutId: 'checkoutId',
  lineId: 'lineId',
  priceId: 'priceId',
  serviceId: 'serviceId',
  stripeCheckoutLineId: 'stripeCheckoutLineId',
  admissionId: 'admissionId',
  orderId: 'orderId',
  draftOrderId: 'draftOrderId',
  stripeInvoiceLineId: 'stripeInvoiceLineId'
} as const

export type InvoiceLineOrderByRelevanceFieldEnum = (typeof InvoiceLineOrderByRelevanceFieldEnum)[keyof typeof InvoiceLineOrderByRelevanceFieldEnum]


export const RefundOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  customerId: 'customerId',
  orderId: 'orderId',
  invoiceId: 'invoiceId',
  totalId: 'totalId',
  totalTaxId: 'totalTaxId',
  currency: 'currency',
  memberId: 'memberId',
  reason: 'reason'
} as const

export type RefundOrderByRelevanceFieldEnum = (typeof RefundOrderByRelevanceFieldEnum)[keyof typeof RefundOrderByRelevanceFieldEnum]


export const RefundLineOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  orderId: 'orderId',
  refundId: 'refundId',
  invoiceId: 'invoiceId',
  invoiceLineId: 'invoiceLineId',
  lineId: 'lineId'
} as const

export type RefundLineOrderByRelevanceFieldEnum = (typeof RefundLineOrderByRelevanceFieldEnum)[keyof typeof RefundLineOrderByRelevanceFieldEnum]


export const AmountOrderByRelevanceFieldEnum = {
  id: 'id',
  currency: 'currency'
} as const

export type AmountOrderByRelevanceFieldEnum = (typeof AmountOrderByRelevanceFieldEnum)[keyof typeof AmountOrderByRelevanceFieldEnum]


export const PayoutOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  stripePayoutId: 'stripePayoutId',
  totalAmountId: 'totalAmountId',
  currency: 'currency',
  description: 'description'
} as const

export type PayoutOrderByRelevanceFieldEnum = (typeof PayoutOrderByRelevanceFieldEnum)[keyof typeof PayoutOrderByRelevanceFieldEnum]


export const BalanceTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  amountId: 'amountId',
  netAmountId: 'netAmountId',
  description: 'description',
  skedyulFeeId: 'skedyulFeeId',
  stripeFeeId: 'stripeFeeId',
  netFeeId: 'netFeeId',
  type: 'type',
  transactionId: 'transactionId',
  payoutId: 'payoutId',
  stripeBalanceTransactionId: 'stripeBalanceTransactionId'
} as const

export type BalanceTransactionOrderByRelevanceFieldEnum = (typeof BalanceTransactionOrderByRelevanceFieldEnum)[keyof typeof BalanceTransactionOrderByRelevanceFieldEnum]


export const CustomerOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  memberId: 'memberId',
  stripeCustomerId: 'stripeCustomerId',
  workplaceId: 'workplaceId',
  billingAddressId: 'billingAddressId'
} as const

export type CustomerOrderByRelevanceFieldEnum = (typeof CustomerOrderByRelevanceFieldEnum)[keyof typeof CustomerOrderByRelevanceFieldEnum]


export const DependantOrderByRelevanceFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  memberId: 'memberId',
  customerId: 'customerId',
  workplaceId: 'workplaceId',
  profileImageUrl: 'profileImageUrl'
} as const

export type DependantOrderByRelevanceFieldEnum = (typeof DependantOrderByRelevanceFieldEnum)[keyof typeof DependantOrderByRelevanceFieldEnum]


export const ImageOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  name: 'name',
  mimeType: 'mimeType'
} as const

export type ImageOrderByRelevanceFieldEnum = (typeof ImageOrderByRelevanceFieldEnum)[keyof typeof ImageOrderByRelevanceFieldEnum]


export const ServiceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  priceId: 'priceId',
  depositId: 'depositId',
  color: 'color',
  memberId: 'memberId'
} as const

export type ServiceOrderByRelevanceFieldEnum = (typeof ServiceOrderByRelevanceFieldEnum)[keyof typeof ServiceOrderByRelevanceFieldEnum]


export const NotificationTemplateOrderByRelevanceFieldEnum = {
  id: 'id',
  subject: 'subject',
  notificationTopicId: 'notificationTopicId',
  workplaceId: 'workplaceId',
  error: 'error',
  fileId: 'fileId'
} as const

export type NotificationTemplateOrderByRelevanceFieldEnum = (typeof NotificationTemplateOrderByRelevanceFieldEnum)[keyof typeof NotificationTemplateOrderByRelevanceFieldEnum]


export const NotificationTopicOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle'
} as const

export type NotificationTopicOrderByRelevanceFieldEnum = (typeof NotificationTopicOrderByRelevanceFieldEnum)[keyof typeof NotificationTopicOrderByRelevanceFieldEnum]


export const NotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  subject: 'subject',
  sender: 'sender',
  recipient: 'recipient',
  senderName: 'senderName',
  workplaceId: 'workplaceId',
  notificationTopicId: 'notificationTopicId',
  contentKey: 'contentKey'
} as const

export type NotificationOrderByRelevanceFieldEnum = (typeof NotificationOrderByRelevanceFieldEnum)[keyof typeof NotificationOrderByRelevanceFieldEnum]


export const AddressOrderByRelevanceFieldEnum = {
  id: 'id',
  company: 'company',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  email: 'email',
  street1: 'street1',
  street2: 'street2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  country: 'country'
} as const

export type AddressOrderByRelevanceFieldEnum = (typeof AddressOrderByRelevanceFieldEnum)[keyof typeof AddressOrderByRelevanceFieldEnum]


export const ProductOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle',
  workplaceId: 'workplaceId',
  memberId: 'memberId'
} as const

export type ProductOrderByRelevanceFieldEnum = (typeof ProductOrderByRelevanceFieldEnum)[keyof typeof ProductOrderByRelevanceFieldEnum]


export const ProductVariantOrderByRelevanceFieldEnum = {
  id: 'id',
  productId: 'productId',
  workplaceId: 'workplaceId',
  name: 'name',
  sku: 'sku',
  priceAmountId: 'priceAmountId',
  comparePriceAmountId: 'comparePriceAmountId',
  memberId: 'memberId'
} as const

export type ProductVariantOrderByRelevanceFieldEnum = (typeof ProductVariantOrderByRelevanceFieldEnum)[keyof typeof ProductVariantOrderByRelevanceFieldEnum]


export const InventoryOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  locationId: 'locationId'
} as const

export type InventoryOrderByRelevanceFieldEnum = (typeof InventoryOrderByRelevanceFieldEnum)[keyof typeof InventoryOrderByRelevanceFieldEnum]


export const MemberOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  clerkUserId: 'clerkUserId',
  clerkOrganizationMembershipId: 'clerkOrganizationMembershipId',
  firstName: 'firstName',
  lastName: 'lastName',
  profileImageUrl: 'profileImageUrl',
  email: 'email',
  phone: 'phone',
  color: 'color'
} as const

export type MemberOrderByRelevanceFieldEnum = (typeof MemberOrderByRelevanceFieldEnum)[keyof typeof MemberOrderByRelevanceFieldEnum]


export const CliTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  token: 'token'
} as const

export type CliTokenOrderByRelevanceFieldEnum = (typeof CliTokenOrderByRelevanceFieldEnum)[keyof typeof CliTokenOrderByRelevanceFieldEnum]


export const ContactOrderByRelevanceFieldEnum = {
  id: 'id',
  customerId: 'customerId',
  workplaceId: 'workplaceId',
  dependantId: 'dependantId',
  lastMessage: 'lastMessage',
  name: 'name'
} as const

export type ContactOrderByRelevanceFieldEnum = (typeof ContactOrderByRelevanceFieldEnum)[keyof typeof ContactOrderByRelevanceFieldEnum]


export const ContactAssociationOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  contactId: 'contactId',
  instanceId: 'instanceId',
  channelModelLinkInstanceId: 'channelModelLinkInstanceId'
} as const

export type ContactAssociationOrderByRelevanceFieldEnum = (typeof ContactAssociationOrderByRelevanceFieldEnum)[keyof typeof ContactAssociationOrderByRelevanceFieldEnum]


export const ContactBlockOrderByRelevanceFieldEnum = {
  id: 'id',
  contactId: 'contactId',
  workplaceId: 'workplaceId'
} as const

export type ContactBlockOrderByRelevanceFieldEnum = (typeof ContactBlockOrderByRelevanceFieldEnum)[keyof typeof ContactBlockOrderByRelevanceFieldEnum]


export const AppOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  handle: 'handle',
  accentColor: 'accentColor',
  bannerUrl: 'bannerUrl',
  description: 'description',
  iconUrl: 'iconUrl',
  publisherLogoUrl: 'publisherLogoUrl',
  publisherName: 'publisherName',
  screenshotUrls: 'screenshotUrls',
  shortDescription: 'shortDescription',
  tags: 'tags',
  websiteUrl: 'websiteUrl',
  defaultBranch: 'defaultBranch',
  githubInstallationId: 'githubInstallationId',
  githubName: 'githubName',
  githubOwner: 'githubOwner',
  githubRepoId: 'githubRepoId',
  ownerId: 'ownerId'
} as const

export type AppOrderByRelevanceFieldEnum = (typeof AppOrderByRelevanceFieldEnum)[keyof typeof AppOrderByRelevanceFieldEnum]


export const DeploymentOrderByRelevanceFieldEnum = {
  id: 'id',
  imageTagId: 'imageTagId',
  imageUri: 'imageUri',
  temporalWorkflowId: 'temporalWorkflowId',
  buildContextS3Path: 'buildContextS3Path',
  computeLayer: 'computeLayer',
  runtime: 'runtime',
  workplaceId: 'workplaceId',
  appId: 'appId',
  commitMessage: 'commitMessage',
  gitBranch: 'gitBranch',
  gitCommitSha: 'gitCommitSha',
  gitOwner: 'gitOwner',
  gitRepo: 'gitRepo',
  gitRepoId: 'gitRepoId',
  projectDirectory: 'projectDirectory',
  sourceType: 'sourceType',
  mode: 'mode',
  githubCheckRunId: 'githubCheckRunId'
} as const

export type DeploymentOrderByRelevanceFieldEnum = (typeof DeploymentOrderByRelevanceFieldEnum)[keyof typeof DeploymentOrderByRelevanceFieldEnum]


export const DeploymentWorkflowVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  deploymentId: 'deploymentId',
  workflowVersionId: 'workflowVersionId'
} as const

export type DeploymentWorkflowVersionOrderByRelevanceFieldEnum = (typeof DeploymentWorkflowVersionOrderByRelevanceFieldEnum)[keyof typeof DeploymentWorkflowVersionOrderByRelevanceFieldEnum]


export const PendingDeploymentOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  lastError: 'lastError'
} as const

export type PendingDeploymentOrderByRelevanceFieldEnum = (typeof PendingDeploymentOrderByRelevanceFieldEnum)[keyof typeof PendingDeploymentOrderByRelevanceFieldEnum]


export const ExecutableOrderByRelevanceFieldEnum = {
  id: 'id',
  appId: 'appId',
  deploymentId: 'deploymentId',
  invokeEndpoint: 'invokeEndpoint',
  arn: 'arn',
  errorMessage: 'errorMessage'
} as const

export type ExecutableOrderByRelevanceFieldEnum = (typeof ExecutableOrderByRelevanceFieldEnum)[keyof typeof ExecutableOrderByRelevanceFieldEnum]


export const AppInstallationOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  appId: 'appId',
  memberId: 'memberId',
  appVersionId: 'appVersionId'
} as const

export type AppInstallationOrderByRelevanceFieldEnum = (typeof AppInstallationOrderByRelevanceFieldEnum)[keyof typeof AppInstallationOrderByRelevanceFieldEnum]


export const AppInstallSetupStepOrderByRelevanceFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  handle: 'handle',
  label: 'label',
  description: 'description'
} as const

export type AppInstallSetupStepOrderByRelevanceFieldEnum = (typeof AppInstallSetupStepOrderByRelevanceFieldEnum)[keyof typeof AppInstallSetupStepOrderByRelevanceFieldEnum]


export const AppCrmMapOrderByRelevanceFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  entityHandle: 'entityHandle',
  targetModelId: 'targetModelId',
  matchFieldId: 'matchFieldId'
} as const

export type AppCrmMapOrderByRelevanceFieldEnum = (typeof AppCrmMapOrderByRelevanceFieldEnum)[keyof typeof AppCrmMapOrderByRelevanceFieldEnum]


export const CommunicationChannelOrderByRelevanceFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  name: 'name',
  identifierValue: 'identifierValue',
  prompt: 'prompt',
  handle: 'handle',
  icon: 'icon',
  inboundAutoJoinAgentId: 'inboundAutoJoinAgentId',
  inboundAutoJoinSenderPattern: 'inboundAutoJoinSenderPattern'
} as const

export type CommunicationChannelOrderByRelevanceFieldEnum = (typeof CommunicationChannelOrderByRelevanceFieldEnum)[keyof typeof CommunicationChannelOrderByRelevanceFieldEnum]


export const AppFieldOrderByRelevanceFieldEnum = {
  id: 'id',
  fieldId: 'fieldId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId',
  entityHandle: 'entityHandle',
  fieldHandle: 'fieldHandle'
} as const

export type AppFieldOrderByRelevanceFieldEnum = (typeof AppFieldOrderByRelevanceFieldEnum)[keyof typeof AppFieldOrderByRelevanceFieldEnum]


export const AppModelOrderByRelevanceFieldEnum = {
  id: 'id',
  entityHandle: 'entityHandle',
  modelId: 'modelId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId'
} as const

export type AppModelOrderByRelevanceFieldEnum = (typeof AppModelOrderByRelevanceFieldEnum)[keyof typeof AppModelOrderByRelevanceFieldEnum]


export const CommunicationChannelSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  communicationChannelId: 'communicationChannelId',
  contactId: 'contactId',
  identifierValue: 'identifierValue',
  linkedIdentifierValueId: 'linkedIdentifierValueId'
} as const

export type CommunicationChannelSubscriptionOrderByRelevanceFieldEnum = (typeof CommunicationChannelSubscriptionOrderByRelevanceFieldEnum)[keyof typeof CommunicationChannelSubscriptionOrderByRelevanceFieldEnum]


export const EnvVariableOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  communicationChannelId: 'communicationChannelId',
  triggerId: 'triggerId',
  appInstallId: 'appInstallId',
  lastFour: 'lastFour',
  workplaceId: 'workplaceId',
  appVersionId: 'appVersionId',
  llmProviderId: 'llmProviderId'
} as const

export type EnvVariableOrderByRelevanceFieldEnum = (typeof EnvVariableOrderByRelevanceFieldEnum)[keyof typeof EnvVariableOrderByRelevanceFieldEnum]


export const AppVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  appId: 'appId',
  description: 'description',
  executableId: 'executableId',
  handle: 'handle',
  name: 'name',
  projectDirectory: 'projectDirectory',
  localDevOwner: 'localDevOwner'
} as const

export type AppVersionOrderByRelevanceFieldEnum = (typeof AppVersionOrderByRelevanceFieldEnum)[keyof typeof AppVersionOrderByRelevanceFieldEnum]


export const AppAccessOrderByRelevanceFieldEnum = {
  id: 'id',
  appId: 'appId',
  workplaceId: 'workplaceId',
  enabledVersions: 'enabledVersions',
  grantedById: 'grantedById',
  note: 'note'
} as const

export type AppAccessOrderByRelevanceFieldEnum = (typeof AppAccessOrderByRelevanceFieldEnum)[keyof typeof AppAccessOrderByRelevanceFieldEnum]


export const AppResourceOrderByRelevanceFieldEnum = {
  id: 'id',
  appVersionId: 'appVersionId',
  handle: 'handle',
  parentId: 'parentId',
  configHash: 'configHash'
} as const

export type AppResourceOrderByRelevanceFieldEnum = (typeof AppResourceOrderByRelevanceFieldEnum)[keyof typeof AppResourceOrderByRelevanceFieldEnum]


export const AppResourceDependencyOrderByRelevanceFieldEnum = {
  id: 'id',
  dependentId: 'dependentId',
  dependencyId: 'dependencyId',
  requiredFields: 'requiredFields'
} as const

export type AppResourceDependencyOrderByRelevanceFieldEnum = (typeof AppResourceDependencyOrderByRelevanceFieldEnum)[keyof typeof AppResourceDependencyOrderByRelevanceFieldEnum]


export const AppResourceInstanceOrderByRelevanceFieldEnum = {
  id: 'id',
  appResourceId: 'appResourceId',
  appInstallationId: 'appInstallationId',
  communicationChannelId: 'communicationChannelId',
  targetId: 'targetId',
  dependsOnInstanceId: 'dependsOnInstanceId',
  configuredAtVersionId: 'configuredAtVersionId',
  driftReason: 'driftReason'
} as const

export type AppResourceInstanceOrderByRelevanceFieldEnum = (typeof AppResourceInstanceOrderByRelevanceFieldEnum)[keyof typeof AppResourceInstanceOrderByRelevanceFieldEnum]


export const DedicatedPhoneNumberOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  phone: 'phone',
  birdChannelId: 'birdChannelId',
  forwardingPhoneNumber: 'forwardingPhoneNumber'
} as const

export type DedicatedPhoneNumberOrderByRelevanceFieldEnum = (typeof DedicatedPhoneNumberOrderByRelevanceFieldEnum)[keyof typeof DedicatedPhoneNumberOrderByRelevanceFieldEnum]


export const ChatOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  contactId: 'contactId',
  token: 'token',
  otp: 'otp'
} as const

export type ChatOrderByRelevanceFieldEnum = (typeof ChatOrderByRelevanceFieldEnum)[keyof typeof ChatOrderByRelevanceFieldEnum]


export const ChatMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  contactId: 'contactId',
  memberId: 'memberId',
  message: 'message',
  workplaceId: 'workplaceId',
  remoteId: 'remoteId',
  subscriptionId: 'subscriptionId',
  generatedSummary: 'generatedSummary',
  contentUrl: 'contentUrl',
  title: 'title',
  agentId: 'agentId',
  workflowRunId: 'workflowRunId',
  workflowRunStepId: 'workflowRunStepId'
} as const

export type ChatMessageOrderByRelevanceFieldEnum = (typeof ChatMessageOrderByRelevanceFieldEnum)[keyof typeof ChatMessageOrderByRelevanceFieldEnum]


export const ToolOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  modelId: 'modelId',
  triggerId: 'triggerId',
  targetAgentId: 'targetAgentId',
  appVersionId: 'appVersionId',
  executableId: 'executableId'
} as const

export type ToolOrderByRelevanceFieldEnum = (typeof ToolOrderByRelevanceFieldEnum)[keyof typeof ToolOrderByRelevanceFieldEnum]


export const AgentRunOrderByRelevanceFieldEnum = {
  id: 'id',
  agentId: 'agentId',
  chatId: 'chatId',
  agentConversationId: 'agentConversationId',
  triggerMessageId: 'triggerMessageId',
  error: 'error',
  llmModelId: 'llmModelId',
  threadId: 'threadId',
  parentRunId: 'parentRunId',
  agentVersionId: 'agentVersionId',
  triggerEventId: 'triggerEventId',
  temporalWorkflowId: 'temporalWorkflowId'
} as const

export type AgentRunOrderByRelevanceFieldEnum = (typeof AgentRunOrderByRelevanceFieldEnum)[keyof typeof AgentRunOrderByRelevanceFieldEnum]


export const ToolCallOrderByRelevanceFieldEnum = {
  id: 'id',
  agentRunId: 'agentRunId',
  toolId: 'toolId',
  error: 'error',
  executableId: 'executableId',
  agentConversationId: 'agentConversationId',
  threadId: 'threadId'
} as const

export type ToolCallOrderByRelevanceFieldEnum = (typeof ToolCallOrderByRelevanceFieldEnum)[keyof typeof ToolCallOrderByRelevanceFieldEnum]


export const MessageAttachmentOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  fileId: 'fileId'
} as const

export type MessageAttachmentOrderByRelevanceFieldEnum = (typeof MessageAttachmentOrderByRelevanceFieldEnum)[keyof typeof MessageAttachmentOrderByRelevanceFieldEnum]


export const WorkflowVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  versionLabel: 'versionLabel',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  appId: 'appId',
  executableId: 'executableId',
  contentHash: 'contentHash'
} as const

export type WorkflowVersionOrderByRelevanceFieldEnum = (typeof WorkflowVersionOrderByRelevanceFieldEnum)[keyof typeof WorkflowVersionOrderByRelevanceFieldEnum]


export const AppVersionWorkflowVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  appVersionId: 'appVersionId',
  workflowVersionId: 'workflowVersionId'
} as const

export type AppVersionWorkflowVersionOrderByRelevanceFieldEnum = (typeof AppVersionWorkflowVersionOrderByRelevanceFieldEnum)[keyof typeof AppVersionWorkflowVersionOrderByRelevanceFieldEnum]


export const ChatReadCursorOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  chatId: 'chatId',
  contactId: 'contactId',
  memberId: 'memberId',
  manualUnreadMessageId: 'manualUnreadMessageId'
} as const

export type ChatReadCursorOrderByRelevanceFieldEnum = (typeof ChatReadCursorOrderByRelevanceFieldEnum)[keyof typeof ChatReadCursorOrderByRelevanceFieldEnum]


export const MemberInboxCursorOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  memberId: 'memberId'
} as const

export type MemberInboxCursorOrderByRelevanceFieldEnum = (typeof MemberInboxCursorOrderByRelevanceFieldEnum)[keyof typeof MemberInboxCursorOrderByRelevanceFieldEnum]


export const WebhookOrderByRelevanceFieldEnum = {
  id: 'id',
  appId: 'appId',
  handle: 'handle',
  displayName: 'displayName',
  description: 'description',
  appVersionId: 'appVersionId'
} as const

export type WebhookOrderByRelevanceFieldEnum = (typeof WebhookOrderByRelevanceFieldEnum)[keyof typeof WebhookOrderByRelevanceFieldEnum]


export const WebhookRegistrationOrderByRelevanceFieldEnum = {
  id: 'id',
  webhookId: 'webhookId',
  appInstallationId: 'appInstallationId',
  path: 'path',
  url: 'url'
} as const

export type WebhookRegistrationOrderByRelevanceFieldEnum = (typeof WebhookRegistrationOrderByRelevanceFieldEnum)[keyof typeof WebhookRegistrationOrderByRelevanceFieldEnum]


export const CronCursorOrderByRelevanceFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  cursorKey: 'cursorKey'
} as const

export type CronCursorOrderByRelevanceFieldEnum = (typeof CronCursorOrderByRelevanceFieldEnum)[keyof typeof CronCursorOrderByRelevanceFieldEnum]


export const CronSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  appInstallationId: 'appInstallationId',
  toolName: 'toolName',
  schedule: 'schedule',
  timezone: 'timezone',
  cursorKey: 'cursorKey',
  label: 'label',
  eventBridgeRuleArn: 'eventBridgeRuleArn'
} as const

export type CronSubscriptionOrderByRelevanceFieldEnum = (typeof CronSubscriptionOrderByRelevanceFieldEnum)[keyof typeof CronSubscriptionOrderByRelevanceFieldEnum]


export const EventListenerOrderByRelevanceFieldEnum = {
  id: 'id',
  triggerId: 'triggerId',
  condition: 'condition',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  identifierKey: 'identifierKey',
  inputsVersionId: 'inputsVersionId'
} as const

export type EventListenerOrderByRelevanceFieldEnum = (typeof EventListenerOrderByRelevanceFieldEnum)[keyof typeof EventListenerOrderByRelevanceFieldEnum]


export const WorkflowOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  handle: 'handle',
  memberId: 'memberId',
  publishTag: 'publishTag',
  appId: 'appId'
} as const

export type WorkflowOrderByRelevanceFieldEnum = (typeof WorkflowOrderByRelevanceFieldEnum)[keyof typeof WorkflowOrderByRelevanceFieldEnum]


export const WorkflowRunOrderByRelevanceFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  workflowVersionId: 'workflowVersionId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  batchJobId: 'batchJobId'
} as const

export type WorkflowRunOrderByRelevanceFieldEnum = (typeof WorkflowRunOrderByRelevanceFieldEnum)[keyof typeof WorkflowRunOrderByRelevanceFieldEnum]


export const WorkflowRunStepOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  workflowRunId: 'workflowRunId',
  handle: 'handle',
  workflowVersionId: 'workflowVersionId',
  triggerId: 'triggerId'
} as const

export type WorkflowRunStepOrderByRelevanceFieldEnum = (typeof WorkflowRunStepOrderByRelevanceFieldEnum)[keyof typeof WorkflowRunStepOrderByRelevanceFieldEnum]


export const AgentOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  system: 'system',
  description: 'description',
  workplaceId: 'workplaceId',
  modelId: 'modelId',
  llmModelId: 'llmModelId',
  appVersionId: 'appVersionId',
  handle: 'handle',
  persona: 'persona',
  personaName: 'personaName'
} as const

export type AgentOrderByRelevanceFieldEnum = (typeof AgentOrderByRelevanceFieldEnum)[keyof typeof AgentOrderByRelevanceFieldEnum]


export const AgentVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  agentId: 'agentId',
  versionLabel: 'versionLabel',
  contentHash: 'contentHash',
  migrateToId: 'migrateToId',
  workplaceId: 'workplaceId',
  appId: 'appId',
  memberId: 'memberId',
  deploymentGroupId: 'deploymentGroupId',
  changeLog: 'changeLog',
  feedbackThreadId: 'feedbackThreadId'
} as const

export type AgentVersionOrderByRelevanceFieldEnum = (typeof AgentVersionOrderByRelevanceFieldEnum)[keyof typeof AgentVersionOrderByRelevanceFieldEnum]


export const SkillOrderByRelevanceFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  appVersionId: 'appVersionId'
} as const

export type SkillOrderByRelevanceFieldEnum = (typeof SkillOrderByRelevanceFieldEnum)[keyof typeof SkillOrderByRelevanceFieldEnum]


export const SkillVersionOrderByRelevanceFieldEnum = {
  id: 'id',
  skillId: 'skillId',
  versionLabel: 'versionLabel',
  contentHash: 'contentHash',
  memberId: 'memberId',
  appVersionId: 'appVersionId'
} as const

export type SkillVersionOrderByRelevanceFieldEnum = (typeof SkillVersionOrderByRelevanceFieldEnum)[keyof typeof SkillVersionOrderByRelevanceFieldEnum]


export const AgentConversationOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  tabId: 'tabId',
  title: 'title',
  agentId: 'agentId'
} as const

export type AgentConversationOrderByRelevanceFieldEnum = (typeof AgentConversationOrderByRelevanceFieldEnum)[keyof typeof AgentConversationOrderByRelevanceFieldEnum]


export const AgentConversationMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  agentId: 'agentId'
} as const

export type AgentConversationMessageOrderByRelevanceFieldEnum = (typeof AgentConversationMessageOrderByRelevanceFieldEnum)[keyof typeof AgentConversationMessageOrderByRelevanceFieldEnum]


export const AgentContextOrderByRelevanceFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  referenceId: 'referenceId',
  modelId: 'modelId',
  label: 'label',
  lastAction: 'lastAction',
  modelLabel: 'modelLabel'
} as const

export type AgentContextOrderByRelevanceFieldEnum = (typeof AgentContextOrderByRelevanceFieldEnum)[keyof typeof AgentContextOrderByRelevanceFieldEnum]


export const TriggerOrderByRelevanceFieldEnum = {
  id: 'id',
  workflowId: 'workflowId',
  workflowVersionId: 'workflowVersionId',
  workplaceId: 'workplaceId',
  handle: 'handle',
  appInstallationId: 'appInstallationId',
  defaultIdentifierKey: 'defaultIdentifierKey'
} as const

export type TriggerOrderByRelevanceFieldEnum = (typeof TriggerOrderByRelevanceFieldEnum)[keyof typeof TriggerOrderByRelevanceFieldEnum]


export const TriggerEventOrderByRelevanceFieldEnum = {
  id: 'id',
  triggerId: 'triggerId',
  workflowRunId: 'workflowRunId'
} as const

export type TriggerEventOrderByRelevanceFieldEnum = (typeof TriggerEventOrderByRelevanceFieldEnum)[keyof typeof TriggerEventOrderByRelevanceFieldEnum]


export const PageComponentOrderByRelevanceFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  customResourceModelId: 'customResourceModelId',
  parentCustomResourceModelId: 'parentCustomResourceModelId'
} as const

export type PageComponentOrderByRelevanceFieldEnum = (typeof PageComponentOrderByRelevanceFieldEnum)[keyof typeof PageComponentOrderByRelevanceFieldEnum]


export const BatchJobOrderByRelevanceFieldEnum = {
  id: 'id',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  actionId: 'actionId',
  label: 'label',
  triggerId: 'triggerId',
  appInstallationId: 'appInstallationId'
} as const

export type BatchJobOrderByRelevanceFieldEnum = (typeof BatchJobOrderByRelevanceFieldEnum)[keyof typeof BatchJobOrderByRelevanceFieldEnum]


export const ActionOrderByRelevanceFieldEnum = {
  id: 'id',
  icon: 'icon',
  triggerId: 'triggerId',
  label: 'label',
  modelId: 'modelId',
  identifierKey: 'identifierKey',
  inputsVersionId: 'inputsVersionId'
} as const

export type ActionOrderByRelevanceFieldEnum = (typeof ActionOrderByRelevanceFieldEnum)[keyof typeof ActionOrderByRelevanceFieldEnum]


export const CustomResourceModelOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  handle: 'handle',
  parentCustomResourceModelId: 'parentCustomResourceModelId',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  plural: 'plural',
  labelTemplate: 'labelTemplate'
} as const

export type CustomResourceModelOrderByRelevanceFieldEnum = (typeof CustomResourceModelOrderByRelevanceFieldEnum)[keyof typeof CustomResourceModelOrderByRelevanceFieldEnum]


export const CustomResourceOrderByRelevanceFieldEnum = {
  id: 'id',
  customResourceModelId: 'customResourceModelId',
  workplaceId: 'workplaceId',
  resourceId: 'resourceId'
} as const

export type CustomResourceOrderByRelevanceFieldEnum = (typeof CustomResourceOrderByRelevanceFieldEnum)[keyof typeof CustomResourceOrderByRelevanceFieldEnum]


export const CampaignOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  customerContext: 'customerContext'
} as const

export type CampaignOrderByRelevanceFieldEnum = (typeof CampaignOrderByRelevanceFieldEnum)[keyof typeof CampaignOrderByRelevanceFieldEnum]


export const CampaignGoalOrderByRelevanceFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  name: 'name',
  context: 'context'
} as const

export type CampaignGoalOrderByRelevanceFieldEnum = (typeof CampaignGoalOrderByRelevanceFieldEnum)[keyof typeof CampaignGoalOrderByRelevanceFieldEnum]


export const CampaignParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  customerId: 'customerId',
  memberId: 'memberId',
  workplaceId: 'workplaceId',
  stagedMessage: 'stagedMessage'
} as const

export type CampaignParticipantOrderByRelevanceFieldEnum = (typeof CampaignParticipantOrderByRelevanceFieldEnum)[keyof typeof CampaignParticipantOrderByRelevanceFieldEnum]


export const MetafieldOrderByRelevanceFieldEnum = {
  id: 'id',
  handle: 'handle',
  customResourceModelId: 'customResourceModelId',
  workplaceId: 'workplaceId',
  definitionHandle: 'definitionHandle',
  label: 'label',
  memberId: 'memberId',
  defaultValue: 'defaultValue',
  helpText: 'helpText',
  filterOptionsBy: 'filterOptionsBy',
  defaultMetafieldDefinitionOptionId: 'defaultMetafieldDefinitionOptionId'
} as const

export type MetafieldOrderByRelevanceFieldEnum = (typeof MetafieldOrderByRelevanceFieldEnum)[keyof typeof MetafieldOrderByRelevanceFieldEnum]


export const MetafieldValueOrderByRelevanceFieldEnum = {
  id: 'id',
  customResourceModelId: 'customResourceModelId',
  customResourceId: 'customResourceId',
  workplaceId: 'workplaceId',
  value: 'value',
  metafieldId: 'metafieldId',
  resourceId: 'resourceId',
  metafieldDefinitionOptionId: 'metafieldDefinitionOptionId'
} as const

export type MetafieldValueOrderByRelevanceFieldEnum = (typeof MetafieldValueOrderByRelevanceFieldEnum)[keyof typeof MetafieldValueOrderByRelevanceFieldEnum]


export const MetafieldDefinitionOrderByRelevanceFieldEnum = {
  handle: 'handle',
  inputType: 'inputType',
  workplaceId: 'workplaceId'
} as const

export type MetafieldDefinitionOrderByRelevanceFieldEnum = (typeof MetafieldDefinitionOrderByRelevanceFieldEnum)[keyof typeof MetafieldDefinitionOrderByRelevanceFieldEnum]


export const MetafieldDefinitionOptionOrderByRelevanceFieldEnum = {
  metafieldDefinitionHandle: 'metafieldDefinitionHandle',
  value: 'value',
  color: 'color',
  description: 'description',
  imageUrl: 'imageUrl',
  label: 'label',
  groupBy: 'groupBy',
  id: 'id'
} as const

export type MetafieldDefinitionOptionOrderByRelevanceFieldEnum = (typeof MetafieldDefinitionOptionOrderByRelevanceFieldEnum)[keyof typeof MetafieldDefinitionOptionOrderByRelevanceFieldEnum]


export const InputTypeOrderByRelevanceFieldEnum = {
  handle: 'handle',
  name: 'name'
} as const

export type InputTypeOrderByRelevanceFieldEnum = (typeof InputTypeOrderByRelevanceFieldEnum)[keyof typeof InputTypeOrderByRelevanceFieldEnum]


export const ImportOrderByRelevanceFieldEnum = {
  id: 'id',
  fileId: 'fileId',
  modelId: 'modelId',
  error: 'error',
  workplaceId: 'workplaceId',
  memberId: 'memberId',
  instanceId: 'instanceId',
  matchOnFieldId: 'matchOnFieldId'
} as const

export type ImportOrderByRelevanceFieldEnum = (typeof ImportOrderByRelevanceFieldEnum)[keyof typeof ImportOrderByRelevanceFieldEnum]


export const ImportRowOrderByRelevanceFieldEnum = {
  id: 'id',
  importId: 'importId',
  error: 'error',
  instanceId: 'instanceId'
} as const

export type ImportRowOrderByRelevanceFieldEnum = (typeof ImportRowOrderByRelevanceFieldEnum)[keyof typeof ImportRowOrderByRelevanceFieldEnum]


export const MigrationOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key'
} as const

export type MigrationOrderByRelevanceFieldEnum = (typeof MigrationOrderByRelevanceFieldEnum)[keyof typeof MigrationOrderByRelevanceFieldEnum]


export const WorkplaceMigrationOrderByRelevanceFieldEnum = {
  id: 'id',
  migrationId: 'migrationId',
  workplaceId: 'workplaceId',
  error: 'error'
} as const

export type WorkplaceMigrationOrderByRelevanceFieldEnum = (typeof WorkplaceMigrationOrderByRelevanceFieldEnum)[keyof typeof WorkplaceMigrationOrderByRelevanceFieldEnum]


export const LlmProviderOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  displayName: 'displayName',
  baseUrl: 'baseUrl',
  workplaceId: 'workplaceId'
} as const

export type LlmProviderOrderByRelevanceFieldEnum = (typeof LlmProviderOrderByRelevanceFieldEnum)[keyof typeof LlmProviderOrderByRelevanceFieldEnum]


export const LlmModelOrderByRelevanceFieldEnum = {
  id: 'id',
  modelId: 'modelId',
  name: 'name',
  description: 'description',
  llmProviderId: 'llmProviderId'
} as const

export type LlmModelOrderByRelevanceFieldEnum = (typeof LlmModelOrderByRelevanceFieldEnum)[keyof typeof LlmModelOrderByRelevanceFieldEnum]


export const LlmUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  llmModelId: 'llmModelId',
  workplaceId: 'workplaceId',
  source: 'source',
  referenceId: 'referenceId',
  referenceType: 'referenceType',
  agentRunId: 'agentRunId'
} as const

export type LlmUsageOrderByRelevanceFieldEnum = (typeof LlmUsageOrderByRelevanceFieldEnum)[keyof typeof LlmUsageOrderByRelevanceFieldEnum]


export const ProvisionOrderByRelevanceFieldEnum = {
  id: 'id',
  appVersionId: 'appVersionId',
  executableId: 'executableId',
  previousExecutableId: 'previousExecutableId',
  temporalWorkflowId: 'temporalWorkflowId',
  currentStep: 'currentStep',
  errorMessage: 'errorMessage'
} as const

export type ProvisionOrderByRelevanceFieldEnum = (typeof ProvisionOrderByRelevanceFieldEnum)[keyof typeof ProvisionOrderByRelevanceFieldEnum]


export const ReportDefinitionOrderByRelevanceFieldEnum = {
  id: 'id',
  handle: 'handle',
  name: 'name',
  description: 'description',
  templateYaml: 'templateYaml',
  workplaceId: 'workplaceId',
  memberId: 'memberId'
} as const

export type ReportDefinitionOrderByRelevanceFieldEnum = (typeof ReportDefinitionOrderByRelevanceFieldEnum)[keyof typeof ReportDefinitionOrderByRelevanceFieldEnum]


export const CRMMigrationOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  sourceId: 'sourceId',
  approvedBy: 'approvedBy',
  deniedBy: 'deniedBy',
  denyReason: 'denyReason',
  errorMessage: 'errorMessage',
  rolledBackBy: 'rolledBackBy',
  rollbackReason: 'rollbackReason',
  batchId: 'batchId',
  createdBy: 'createdBy'
} as const

export type CRMMigrationOrderByRelevanceFieldEnum = (typeof CRMMigrationOrderByRelevanceFieldEnum)[keyof typeof CRMMigrationOrderByRelevanceFieldEnum]


export const CRMOperationOrderByRelevanceFieldEnum = {
  id: 'id',
  migrationId: 'migrationId',
  resourceId: 'resourceId',
  resourceHandle: 'resourceHandle',
  impactSummary: 'impactSummary',
  errorMessage: 'errorMessage'
} as const

export type CRMOperationOrderByRelevanceFieldEnum = (typeof CRMOperationOrderByRelevanceFieldEnum)[keyof typeof CRMOperationOrderByRelevanceFieldEnum]


export const ThreadWorkflowRunOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workflowRunId: 'workflowRunId',
  handle: 'handle',
  startedByHookId: 'startedByHookId',
  sourceMessageId: 'sourceMessageId',
  cancelReason: 'cancelReason'
} as const

export type ThreadWorkflowRunOrderByRelevanceFieldEnum = (typeof ThreadWorkflowRunOrderByRelevanceFieldEnum)[keyof typeof ThreadWorkflowRunOrderByRelevanceFieldEnum]


export const ParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  contactId: 'contactId',
  memberId: 'memberId',
  agentId: 'agentId',
  contactAssociationId: 'contactAssociationId',
  displayName: 'displayName',
  avatarUrl: 'avatarUrl',
  externalId: 'externalId',
  batchJobId: 'batchJobId',
  workflowId: 'workflowId'
} as const

export type ParticipantOrderByRelevanceFieldEnum = (typeof ParticipantOrderByRelevanceFieldEnum)[keyof typeof ParticipantOrderByRelevanceFieldEnum]


export const ThreadOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  parentId: 'parentId',
  sourceMessageId: 'sourceMessageId',
  title: 'title',
  lastActivityType: 'lastActivityType',
  externalId: 'externalId',
  lastSummarizedMsgId: 'lastSummarizedMsgId',
  sessionId: 'sessionId',
  communicationChannelId: 'communicationChannelId',
  routingAddress: 'routingAddress',
  routingParticipantId: 'routingParticipantId',
  routingPattern: 'routingPattern',
  routingPatternDisplay: 'routingPatternDisplay'
} as const

export type ThreadOrderByRelevanceFieldEnum = (typeof ThreadOrderByRelevanceFieldEnum)[keyof typeof ThreadOrderByRelevanceFieldEnum]


export const ThreadParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  participantId: 'participantId',
  lockedAgentVersionId: 'lockedAgentVersionId',
  previousVersionId: 'previousVersionId',
  activeAgentRunId: 'activeAgentRunId',
  lockedWorkflowVersionId: 'lockedWorkflowVersionId'
} as const

export type ThreadParticipantOrderByRelevanceFieldEnum = (typeof ThreadParticipantOrderByRelevanceFieldEnum)[keyof typeof ThreadParticipantOrderByRelevanceFieldEnum]


export const ScheduledEventOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  agentId: 'agentId',
  eventType: 'eventType',
  cancelledBy: 'cancelledBy',
  reason: 'reason'
} as const

export type ScheduledEventOrderByRelevanceFieldEnum = (typeof ScheduledEventOrderByRelevanceFieldEnum)[keyof typeof ScheduledEventOrderByRelevanceFieldEnum]


export const ScheduledMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  senderId: 'senderId',
  content: 'content',
  cancelledReason: 'cancelledReason',
  createdMessageId: 'createdMessageId',
  approvedBy: 'approvedBy',
  approvalBlockId: 'approvalBlockId',
  batchJobId: 'batchJobId'
} as const

export type ScheduledMessageOrderByRelevanceFieldEnum = (typeof ScheduledMessageOrderByRelevanceFieldEnum)[keyof typeof ScheduledMessageOrderByRelevanceFieldEnum]


export const ThreadMessageOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  senderId: 'senderId',
  content: 'content',
  contentRaw: 'contentRaw',
  contentFormat: 'contentFormat',
  externalId: 'externalId',
  deletedBy: 'deletedBy',
  replyToMessageId: 'replyToMessageId',
  agentRunId: 'agentRunId',
  workflowRunId: 'workflowRunId',
  batchJobId: 'batchJobId',
  callSessionId: 'callSessionId'
} as const

export type ThreadMessageOrderByRelevanceFieldEnum = (typeof ThreadMessageOrderByRelevanceFieldEnum)[keyof typeof ThreadMessageOrderByRelevanceFieldEnum]


export const ThreadMessageAttachmentOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  fileId: 'fileId'
} as const

export type ThreadMessageAttachmentOrderByRelevanceFieldEnum = (typeof ThreadMessageAttachmentOrderByRelevanceFieldEnum)[keyof typeof ThreadMessageAttachmentOrderByRelevanceFieldEnum]


export const MessageOutboxOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  messageId: 'messageId',
  appInstallationId: 'appInstallationId',
  channelId: 'channelId',
  sendToolName: 'sendToolName',
  sendBatchToolName: 'sendBatchToolName',
  batchJobId: 'batchJobId',
  routingAddress: 'routingAddress',
  routingParticipantId: 'routingParticipantId',
  externalGroupId: 'externalGroupId',
  lastError: 'lastError',
  usedInvokeUrl: 'usedInvokeUrl'
} as const

export type MessageOutboxOrderByRelevanceFieldEnum = (typeof MessageOutboxOrderByRelevanceFieldEnum)[keyof typeof MessageOutboxOrderByRelevanceFieldEnum]


export const MessageInboxOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  communicationChannelId: 'communicationChannelId',
  senderIdentifierValue: 'senderIdentifierValue',
  receiverIdentifierValue: 'receiverIdentifierValue',
  messageContent: 'messageContent',
  messageContentRaw: 'messageContentRaw',
  messageTitle: 'messageTitle',
  externalMessageId: 'externalMessageId',
  lastError: 'lastError',
  threadId: 'threadId',
  contactId: 'contactId'
} as const

export type MessageInboxOrderByRelevanceFieldEnum = (typeof MessageInboxOrderByRelevanceFieldEnum)[keyof typeof MessageInboxOrderByRelevanceFieldEnum]


export const EventOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  type: 'type',
  resourceType: 'resourceType',
  resourceId: 'resourceId',
  error: 'error',
  emittedBy: 'emittedBy'
} as const

export type EventOrderByRelevanceFieldEnum = (typeof EventOrderByRelevanceFieldEnum)[keyof typeof EventOrderByRelevanceFieldEnum]


export const EventSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  agentId: 'agentId',
  triggerId: 'triggerId',
  eventType: 'eventType',
  condition: 'condition',
  description: 'description'
} as const

export type EventSubscriptionOrderByRelevanceFieldEnum = (typeof EventSubscriptionOrderByRelevanceFieldEnum)[keyof typeof EventSubscriptionOrderByRelevanceFieldEnum]


export const ThreadBlockOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  participantId: 'participantId',
  content: 'content',
  parentBlockId: 'parentBlockId',
  messageId: 'messageId',
  agentRunId: 'agentRunId',
  workflowRunId: 'workflowRunId',
  subThreadId: 'subThreadId',
  threadLinkId: 'threadLinkId',
  callSessionId: 'callSessionId'
} as const

export type ThreadBlockOrderByRelevanceFieldEnum = (typeof ThreadBlockOrderByRelevanceFieldEnum)[keyof typeof ThreadBlockOrderByRelevanceFieldEnum]


export const ThreadReadCursorOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  threadParticipantId: 'threadParticipantId',
  lastReadMessageId: 'lastReadMessageId'
} as const

export type ThreadReadCursorOrderByRelevanceFieldEnum = (typeof ThreadReadCursorOrderByRelevanceFieldEnum)[keyof typeof ThreadReadCursorOrderByRelevanceFieldEnum]


export const ThreadContextOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  instanceId: 'instanceId',
  linkedThreadId: 'linkedThreadId',
  documentUrl: 'documentUrl',
  reason: 'reason',
  externalId: 'externalId',
  handle: 'handle'
} as const

export type ThreadContextOrderByRelevanceFieldEnum = (typeof ThreadContextOrderByRelevanceFieldEnum)[keyof typeof ThreadContextOrderByRelevanceFieldEnum]


export const ThreadLinkOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  sourceThreadId: 'sourceThreadId',
  targetThreadId: 'targetThreadId',
  initiatorId: 'initiatorId',
  sourceMessageId: 'sourceMessageId',
  reason: 'reason',
  workflowRunId: 'workflowRunId',
  workflowRunStepId: 'workflowRunStepId',
  agentRunId: 'agentRunId',
  createdBy: 'createdBy',
  createdByMemberId: 'createdByMemberId',
  purpose: 'purpose',
  contextSummary: 'contextSummary',
  resolution: 'resolution'
} as const

export type ThreadLinkOrderByRelevanceFieldEnum = (typeof ThreadLinkOrderByRelevanceFieldEnum)[keyof typeof ThreadLinkOrderByRelevanceFieldEnum]


export const ThreadTopicOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  name: 'name',
  handle: 'handle',
  description: 'description',
  color: 'color',
  icon: 'icon'
} as const

export type ThreadTopicOrderByRelevanceFieldEnum = (typeof ThreadTopicOrderByRelevanceFieldEnum)[keyof typeof ThreadTopicOrderByRelevanceFieldEnum]


export const MessageTopicOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  topicId: 'topicId',
  assignedBy: 'assignedBy'
} as const

export type MessageTopicOrderByRelevanceFieldEnum = (typeof MessageTopicOrderByRelevanceFieldEnum)[keyof typeof MessageTopicOrderByRelevanceFieldEnum]


export const MessageTagOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  name: 'name',
  handle: 'handle',
  color: 'color'
} as const

export type MessageTagOrderByRelevanceFieldEnum = (typeof MessageTagOrderByRelevanceFieldEnum)[keyof typeof MessageTagOrderByRelevanceFieldEnum]


export const MessageTagAssignmentOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  tagId: 'tagId',
  assignedBy: 'assignedBy'
} as const

export type MessageTagAssignmentOrderByRelevanceFieldEnum = (typeof MessageTagAssignmentOrderByRelevanceFieldEnum)[keyof typeof MessageTagAssignmentOrderByRelevanceFieldEnum]


export const DecisionTypeOrderByRelevanceFieldEnum = {
  id: 'id',
  workplaceId: 'workplaceId',
  handle: 'handle',
  name: 'name',
  description: 'description',
  category: 'category',
  workflowId: 'workflowId',
  extractionHints: 'extractionHints'
} as const

export type DecisionTypeOrderByRelevanceFieldEnum = (typeof DecisionTypeOrderByRelevanceFieldEnum)[keyof typeof DecisionTypeOrderByRelevanceFieldEnum]


export const ThreadDecisionOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  title: 'title',
  summary: 'summary',
  sourceMessageIds: 'sourceMessageIds',
  decisionTypeId: 'decisionTypeId',
  madeBy: 'madeBy',
  topicId: 'topicId',
  automationRunId: 'automationRunId'
} as const

export type ThreadDecisionOrderByRelevanceFieldEnum = (typeof ThreadDecisionOrderByRelevanceFieldEnum)[keyof typeof ThreadDecisionOrderByRelevanceFieldEnum]


export const ThreadSummaryOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  summary: 'summary',
  fromMessageId: 'fromMessageId',
  toMessageId: 'toMessageId',
  topicId: 'topicId'
} as const

export type ThreadSummaryOrderByRelevanceFieldEnum = (typeof ThreadSummaryOrderByRelevanceFieldEnum)[keyof typeof ThreadSummaryOrderByRelevanceFieldEnum]


export const MessageEmbeddingOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  workplaceId: 'workplaceId',
  model: 'model',
  embeddedContent: 'embeddedContent'
} as const

export type MessageEmbeddingOrderByRelevanceFieldEnum = (typeof MessageEmbeddingOrderByRelevanceFieldEnum)[keyof typeof MessageEmbeddingOrderByRelevanceFieldEnum]


export const CallSessionOrderByRelevanceFieldEnum = {
  id: 'id',
  threadId: 'threadId',
  workplaceId: 'workplaceId',
  communicationChannelId: 'communicationChannelId',
  externalStatus: 'externalStatus',
  initiatorId: 'initiatorId',
  initiatorCallParticipantId: 'initiatorCallParticipantId',
  fromNumber: 'fromNumber',
  toNumber: 'toNumber',
  forwardedToNumber: 'forwardedToNumber',
  externalId: 'externalId',
  joinUrl: 'joinUrl',
  recordingUrl: 'recordingUrl',
  recordingSid: 'recordingSid',
  transcriptionEngine: 'transcriptionEngine',
  transcriptionSid: 'transcriptionSid',
  summary: 'summary',
  summaryMessageId: 'summaryMessageId'
} as const

export type CallSessionOrderByRelevanceFieldEnum = (typeof CallSessionOrderByRelevanceFieldEnum)[keyof typeof CallSessionOrderByRelevanceFieldEnum]


export const CallRecordingChunkOrderByRelevanceFieldEnum = {
  id: 'id',
  callSessionId: 'callSessionId',
  fileId: 'fileId',
  mimeType: 'mimeType'
} as const

export type CallRecordingChunkOrderByRelevanceFieldEnum = (typeof CallRecordingChunkOrderByRelevanceFieldEnum)[keyof typeof CallRecordingChunkOrderByRelevanceFieldEnum]


export const CallParticipantOrderByRelevanceFieldEnum = {
  id: 'id',
  callSessionId: 'callSessionId',
  threadParticipantId: 'threadParticipantId',
  displayName: 'displayName',
  dialInNumber: 'dialInNumber',
  phoneNumber: 'phoneNumber',
  trackLabel: 'trackLabel',
  externalId: 'externalId'
} as const

export type CallParticipantOrderByRelevanceFieldEnum = (typeof CallParticipantOrderByRelevanceFieldEnum)[keyof typeof CallParticipantOrderByRelevanceFieldEnum]


export const MessageReactionOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  participantId: 'participantId',
  emoji: 'emoji',
  emojiName: 'emojiName',
  externalId: 'externalId'
} as const

export type MessageReactionOrderByRelevanceFieldEnum = (typeof MessageReactionOrderByRelevanceFieldEnum)[keyof typeof MessageReactionOrderByRelevanceFieldEnum]


export const MessageMentionOrderByRelevanceFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  participantId: 'participantId',
  externalId: 'externalId'
} as const

export type MessageMentionOrderByRelevanceFieldEnum = (typeof MessageMentionOrderByRelevanceFieldEnum)[keyof typeof MessageMentionOrderByRelevanceFieldEnum]

